/**
 * MERIT Beauty Master Catalog Registry
 * Rich data for all in-store products & calibrated color registry
 */
window.MERIT_CATALOG_DATA = {
  "the-minimalist": {
    "handle": "the-minimalist",
    "title": "The Minimalist",
    "subtitle": "Perfecting Complexion Stick",
    "short_description": "A lightweight, buildable formula that visibly blurs imperfections and evens skin tone for natural-looking coverage. It’s the foundation stick that makes your skin look like skin.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "A lightweight, buildable complexion stick that gives natural-looking coverage",
      "Visibly blurs imperfections and evens skin tone",
      "Clinically proven to wear comfortably all day",
      "Can be used all over for full coverage or to make small edits only where needed",
      "Sea daffodil extract helps diminish the appearance of pigmentation",
      "Fatty acids help condition skin and lock in moisture",
      "Sweat, humidity and transfer-resistant",
      "Non-comedogenic and oil-free",
      "Safe for sensitive skin",
      "Dermatologist-tested"
    ],
    "key_ingredients": [
      {
        "name": "Sea Daffodil Extract",
        "role": "Brightening Botanical Active",
        "benefit": "Helps diminish the look of dark spots, discoloration, and pigmentation over time."
      },
      {
        "name": "Fatty Acids (Linoleic & Oleic)",
        "role": "Lipid Barrier & Conditioner",
        "benefit": "Condition the skin and lock in all-day moisture without clogging pores."
      }
    ],
    "how_to_use": [
      "Apply it all over for full coverage",
      "Use it as a spot concealer",
      "Blend using your fingertips or Brush No. 1",
      "Use a shade lighter to brighten under the eyes"
    ],
    "faqs": [
      {
        "q": "What is The Minimalist Perfecting Complexion Stick?",
        "a": "A lightweight, buildable complexion stick from MERIT that replaces both foundation and concealer for a natural, skin-like finish."
      },
      {
        "q": "How do I apply it?",
        "a": "Spot conceal only where needed or swipe it all over for full coverage, then buff with Brush No.1. Use a shade lighter to brighten under the eyes."
      },
      {
        "q": "What coverage and wear can I expect?",
        "a": "It visibly blurs and evens skin tone with buildable coverage, and is clinically proven to wear comfortably all day. It’s also transfer, sweat, and humidity-resistant."
      },
      {
        "q": "Is it safe for sensitive or acne‑prone skin?",
        "a": "Yes—it's dermatologist-tested, non‑comedogenic, and won’t break you out."
      },
      {
        "q": "What’s in the formula (and what isn’t)?",
        "a": "Sea Daffodil Extract helps diminish the look of pigmentation and fatty acids condition and lock in moisture—without comedogenic ingredients, fragrance, oil, or animal-derived ingredients."
      },
      {
        "q": "Is it vegan and cruelty‑free?",
        "a": "Yes—it's vegan, Leaping Bunny–certified, and Clean at MERIT + EU‑compliant."
      },
      {
        "q": "How do I find my shade?",
        "a": "Use our Shade Finder , and if the first isn’t quite right, our 30‑Day Shade Match Promise will help you swap for your match."
      },
      {
        "q": "What shades and undertones does it cover?",
        "a": "The range spans very fair to rich with warm, cool, neutral, and olive undertones."
      },
      {
        "q": "How should I prep for best results?",
        "a": "Apply Great Skin Serum and Great Skin Moisturize r, then use The Minimalist and blend with Brush No.1 ."
      }
    ],
    "shade_count": 30,
    "sample_shades": [
      {
        "name": "Bistre",
        "hex": "#4F3228"
      },
      {
        "name": "Umber",
        "hex": "#5A3F29"
      },
      {
        "name": "Cacao",
        "hex": "#754B33"
      },
      {
        "name": "Sepia",
        "hex": "#6C462C"
      }
    ],
    "all_shades": [
      {
        "id": 44164184670394,
        "name": "Bistre",
        "hex": "#4F3228",
        "price": 38,
        "available": true,
        "sku": "M003-30-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-BISTRE.jpg?v=1767637763"
      },
      {
        "id": 36369073995933,
        "name": "Umber",
        "hex": "#5A3F29",
        "price": 38,
        "available": true,
        "sku": "M003-19-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-UMBER_4bc47fd0-ae52-47c9-ab78-9a979ca46ff9.jpg?v=1767637763"
      },
      {
        "id": 36369074028701,
        "name": "Cacao",
        "hex": "#754B33",
        "price": 38,
        "available": true,
        "sku": "M003-18-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CACAO_17fed8a4-71ca-46a5-9b49-196eb0e14618.jpg?v=1767637763"
      },
      {
        "id": 36369074061469,
        "name": "Sepia",
        "hex": "#6C462C",
        "price": 38,
        "available": true,
        "sku": "M003-20-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-SEPIA.jpg?v=1767637763"
      },
      {
        "id": 44164184703162,
        "name": "Taurillon",
        "hex": "#83452D",
        "price": 38,
        "available": true,
        "sku": "M003-29-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-TAURILLON.jpg?v=1767637763"
      },
      {
        "id": 36369074094237,
        "name": "Tiger Eye",
        "hex": "#955428",
        "price": 38,
        "available": true,
        "sku": "M003-17-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-TIGERSEYE.jpg?v=1767637763"
      },
      {
        "id": 36369074192541,
        "name": "Amber",
        "hex": "#A76441",
        "price": 38,
        "available": true,
        "sku": "M003-14-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-AMBER.jpg?v=1767637763"
      },
      {
        "id": 36369074127005,
        "name": "Chestnut",
        "hex": "#955939",
        "price": 38,
        "available": true,
        "sku": "M003-16-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CHESTNUT.jpg?v=1767637763"
      },
      {
        "id": 36369074159773,
        "name": "Sienna",
        "hex": "#A46B41",
        "price": 38,
        "available": true,
        "sku": "M003-15-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-SIENNA_cb77de55-c1c0-43ae-ae00-777e8288fdbc.jpg?v=1767637763"
      },
      {
        "id": 44164184735930,
        "name": "Calico",
        "hex": "#B0795A",
        "price": 38,
        "available": true,
        "sku": "M003-28-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CALICO.jpg?v=1767637763"
      },
      {
        "id": 36369074225309,
        "name": "Buff",
        "hex": "#C18B50",
        "price": 38,
        "available": true,
        "sku": "M003-13-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-BUFF.jpg?v=1767637763"
      },
      {
        "id": 36369074258077,
        "name": "Khaki",
        "hex": "#A17241",
        "price": 38,
        "available": true,
        "sku": "M003-12-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-KHAKI_c772943b-2709-48c5-a769-01b969dc7aa0.jpg?v=1767637763"
      },
      {
        "id": 44164184768698,
        "name": "Burlwood",
        "hex": "#CB9163",
        "price": 38,
        "available": true,
        "sku": "M003-27-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-BURLWOOD.jpg?v=1767637763"
      },
      {
        "id": 36369074323613,
        "name": "Camel",
        "hex": "#B77645",
        "price": 38,
        "available": true,
        "sku": "M003-10-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CAMEL_c2b4d49f-b7fb-4772-b1b0-edb8999f6363.jpg?v=1767637763"
      },
      {
        "id": 36369074290845,
        "name": "Suede",
        "hex": "#AD794A",
        "price": 38,
        "available": true,
        "sku": "M003-11-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-SUEDE_82023290-c704-4389-9370-983879f4b326.jpg?v=1767637763"
      },
      {
        "id": 44164184801466,
        "name": "Jute",
        "hex": "#B98F77",
        "price": 38,
        "available": true,
        "sku": "M003-26-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-JUTE_ea0fe434-5200-4a7c-94db-5796c1fa79b5.jpg?v=1767637763"
      },
      {
        "id": 44164184834234,
        "name": "Palomino",
        "hex": "#DEAF8B",
        "price": 38,
        "available": true,
        "sku": "M003-25-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-PALOMINO_d0b71547-20f7-4bff-b836-b8e27a8aa283.jpg?v=1767637763"
      },
      {
        "id": 36369074356381,
        "name": "Sand",
        "hex": "#EDB785",
        "price": 38,
        "available": true,
        "sku": "M003-09-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-Sand_dd0cc360-39b6-467d-a43c-99295873514c.jpg?v=1767637763"
      },
      {
        "id": 36369074421917,
        "name": "Ochre",
        "hex": "#FFC78E",
        "price": 38,
        "available": true,
        "sku": "M003-07-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-OCHRE_4d313c06-06d6-45b6-905e-85c62fa54445.jpg?v=1767637763"
      },
      {
        "id": 36369074389149,
        "name": "Bisque",
        "hex": "#F5B785",
        "price": 38,
        "available": true,
        "sku": "M003-08-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-BISQUE_13d64b8a-4d5b-408f-bc6a-aff37e2aba01.jpg?v=1767637763"
      },
      {
        "id": 44164184867002,
        "name": "Oak",
        "hex": "#DDB18C",
        "price": 38,
        "available": true,
        "sku": "M003-24-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-OAK.jpg?v=1767637763"
      },
      {
        "id": 44164184899770,
        "name": "Sandstone",
        "hex": "#DFB89B",
        "price": 38,
        "available": true,
        "sku": "M003-23-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-SANDSTONE.jpg?v=1767637763"
      },
      {
        "id": 36369074454685,
        "name": "Ecru",
        "hex": "#FFCD97",
        "price": 38,
        "available": true,
        "sku": "M003-06-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-Ecru_a5f2ac48-c4d5-4e91-bcd6-abbe86272e81.jpg?v=1767637763"
      },
      {
        "id": 36369074487453,
        "name": "Dune",
        "hex": "#F4BF9E",
        "price": 38,
        "available": true,
        "sku": "M003-05-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-Dune_4d1a5280-6298-4bc6-b092-63812a065ec4.jpg?v=1767637763"
      },
      {
        "id": 36369074520221,
        "name": "Linen",
        "hex": "#ECC195",
        "price": 38,
        "available": true,
        "sku": "M003-04-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-Linen_8e5b8414-590a-4a1c-922b-90a2c1fefce6.jpg?v=1767637763"
      },
      {
        "id": 36369074585757,
        "name": "Bone",
        "hex": "#E8C1A9",
        "price": 38,
        "available": true,
        "sku": "M003-01-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-BONE.jpg?v=1767637763"
      },
      {
        "id": 36369074552989,
        "name": "Cream",
        "hex": "#F4C199",
        "price": 38,
        "available": true,
        "sku": "M003-03-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CREAM_e11c8781-fc5e-4dc9-9753-3450fac814bd.jpg?v=1767637763"
      },
      {
        "id": 36369074618525,
        "name": "Silk",
        "hex": "#F5C19E",
        "price": 38,
        "available": true,
        "sku": "M003-02-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-SILK_4aab80a5-435d-4e58-931a-568707244d9e.jpg?v=1770839115"
      },
      {
        "id": 44164184932538,
        "name": "Chiffon",
        "hex": "#E7D0B9",
        "price": 38,
        "available": true,
        "sku": "M003-22-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CHIFFON_7b58d372-fccd-4802-a0f9-aedac3db5cc2.jpg?v=1767637763"
      },
      {
        "id": 44164184965306,
        "name": "Ceramic",
        "hex": "#DBC6C0",
        "price": 38,
        "available": true,
        "sku": "M003-21-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Minimalist-CERAMIC.jpg?v=1767637763"
      }
    ]
  },
  "flush-balm": {
    "handle": "flush-balm",
    "title": "Flush Balm",
    "subtitle": "Cheek Color",
    "short_description": "A cream tint that melts into skin for lit-from-within color that stays flush all day.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Microfine pigment powders give a touch of color without covering up your natural skin texture",
      "Lightweight, buildable formula leaves a long-lasting glow that’s never heavy or cakey",
      "Can be used on cheeks and lip",
      "Vitamin E conditions skin",
      "Non-comedogenic",
      "Fragrance-free",
      "Safe for sensitive skin"
    ],
    "key_ingredients": [
      {
        "name": "Vitamin E (Tocopherol)",
        "role": "Antioxidant & Skin Conditioner",
        "benefit": "Provides vital antioxidant protection while conditioning skin for a healthy, lit-from-within glow."
      },
      {
        "name": "Octyldodecanol",
        "role": "Emollient Carrier",
        "benefit": "Ensures silky, smooth, even gliding application without clinging to texture or dry patches."
      }
    ],
    "how_to_use": [
      "Swipe directly onto cheeks or lips",
      "Blend in with your fingertips or Brush No. 1",
      "Layer for more saturated color"
    ],
    "faqs": [
      {
        "q": "What is Flush Balm by MERIT?",
        "a": "A lightweight cream blush that melts into skin for lit-from-within color with a natural-looking finish."
      },
      {
        "q": "How do I use Flush Balm?",
        "a": "Apply to cheeks for a soft, buildable flush and tap onto lips for a hint of color."
      },
      {
        "q": "What finish and coverage does it give?",
        "a": "Lightweight and blendable with a satin, natural finish that builds from sheer without looking heavy or cakey."
      },
      {
        "q": "Is it safe for sensitive or acne-prone skin?",
        "a": "Yes—it’s fragrance-free, formulated without acne-triggering ingredients, and safe for sensitive and acne-prone skin."
      },
      {
        "q": "What are the key ingredients?",
        "a": "Vitamin E to condition skin, microfine pigment powders for natural-looking color, and octyldodecanol for smooth, even application."
      },
      {
        "q": "Is Flush Balm vegan and cruelty-free?",
        "a": "Yes—it’s Clean at MERIT and EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "What shades are available?",
        "a": "A curated range for fair to rich skin tones, including soft peach, cool mauve, sheer red, warm taupe, bright pink, and more."
      },
      {
        "q": "How long does it wear?",
        "a": "The lightweight, buildable formula leaves a long-lasting glow that stays flush all day."
      },
      {
        "q": "Is the packaging recyclable?",
        "a": "The component uses 43% recycled plastic with a 30% PCR cap. Our signature packaging is recyclable, reusable, or compostable, and the unit carton is FSC-certified."
      }
    ],
    "shade_count": 13,
    "sample_shades": [
      {
        "name": "Beverly Hills",
        "hex": "#C76153"
      },
      {
        "name": "Stockholm",
        "hex": "#E17C8C"
      },
      {
        "name": "Archival",
        "hex": "#A95E62"
      },
      {
        "name": "Cheeky",
        "hex": "#B25659"
      }
    ],
    "all_shades": [
      {
        "id": 36369065312413,
        "name": "Beverly Hills",
        "hex": "#C76153",
        "price": 30,
        "available": true,
        "sku": "M007-02-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-FlushBalm-BeverlyHills_4441fb1a-b860-4dfa-a0d9-e0b3f8d88098.jpg?v=1762550276"
      },
      {
        "id": 42159983689914,
        "name": "Stockholm",
        "hex": "#E17C8C",
        "price": 30,
        "available": true,
        "sku": "M007-11-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Stockholm_665262f5-fba9-4bdf-9129-0297b79170e1.jpg?v=1762550276"
      },
      {
        "id": 44482635399354,
        "name": "Archival",
        "hex": "#A95E62",
        "price": 30,
        "available": true,
        "sku": "M007-23-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Archival-Product_8a2a599f-451f-40bd-9984-af91aef96e81.jpg?v=1762550276"
      },
      {
        "id": 36369065345181,
        "name": "Cheeky",
        "hex": "#B25659",
        "price": 30,
        "available": true,
        "sku": "M007-03-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Cheeky.jpg?v=1762550276"
      },
      {
        "id": 44482635333818,
        "name": "Le Bonbon",
        "hex": "#D33762",
        "price": 30,
        "available": true,
        "sku": "M007-21-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-LeBonBon_d2410c82-9e63-4fdb-b7a1-24bbfc764f41.jpg?v=1770735412"
      },
      {
        "id": 42159981232314,
        "name": "Fox",
        "hex": "#AA5048",
        "price": 30,
        "available": true,
        "sku": "M007-09-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Fox-Product.jpg?v=1762550276"
      },
      {
        "id": 42159970877626,
        "name": "Après",
        "hex": "#872230",
        "price": 30,
        "available": true,
        "sku": "M007-10-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Apres-Product.jpg?v=1762550276"
      },
      {
        "id": 44482635432122,
        "name": "Postmodern",
        "hex": "#661E1D",
        "price": 30,
        "available": true,
        "sku": "M007-24-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-PostModern-Product.jpg?v=1762550276"
      },
      {
        "id": 42159987294394,
        "name": "Persimmon",
        "hex": "#B93721",
        "price": 30,
        "available": true,
        "sku": "M007-12-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Persimmon-Product.jpg?v=1762550276"
      },
      {
        "id": 44482635366586,
        "name": "Lusitano",
        "hex": "#E1544B",
        "price": 30,
        "available": true,
        "sku": "M007-22-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Lusitano_e57d2b0a-df1a-4927-833c-012d59564c8f.jpg?v=1762550276"
      },
      {
        "id": 43054076133562,
        "name": "Rouge",
        "hex": "#EB2B41",
        "price": 30,
        "available": true,
        "sku": "M007-18-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Rouge_b6e11cbe-8a93-4657-93bd-59f11f474bc8.jpg?v=1762550276"
      },
      {
        "id": 44482635301050,
        "name": "Terracotta",
        "hex": "#B26C52",
        "price": 30,
        "available": true,
        "sku": "M007-26-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-Terracotta-Product_89f0ae62-ea04-419d-8de1-55416a367780.jpg?v=1762550276"
      },
      {
        "id": 44482635464890,
        "name": "Bespoke",
        "hex": "#814A4A",
        "price": 30,
        "available": true,
        "sku": "M007-25-0002",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT24-FlushBalm-BeSpoke.jpg?v=1770839115"
      }
    ]
  },
  "bronze-balm": {
    "handle": "bronze-balm",
    "title": "Bronze Balm",
    "subtitle": "Sheer Bronzer",
    "short_description": "The easiest bronzer — ever. This sheer, buildable cream bronzer gives a wash of natural-looking warmth and depth.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Sheer, buildable cream formula that blends in without streaks",
      "Creates natural-looking warmth and soft definition",
      "Blends in seamlessly for a second-skin finish that’s never cakey",
      "Fatty acids condition skin and lock in moisture"
    ],
    "key_ingredients": [
      {
        "name": "Vitamin E",
        "role": "Antioxidant & Skin Conditioner",
        "benefit": "Conditions skin and neutralizes environmental free radicals."
      },
      {
        "name": "Octyldodecanol",
        "role": "Cushioning Emollient",
        "benefit": "Allows seamless, streak-free blending and a weightless cream-to-skin slip."
      }
    ],
    "how_to_use": [
      "For warmth, use the wide side to swipe anywhere the sun naturally hits",
      "To sculpt, use the narrow side for precise application",
      "Blend with Brush No. 1 or your fingers"
    ],
    "faqs": [
      {
        "q": "How do I apply Bronze Balm for a natural look?",
        "a": "For warmth, swipe the wide side anywhere the sun naturally hits; to sculpt, use the narrow side for precise definition. Blend with Brush No. 1 or your fingers."
      },
      {
        "q": "What finish and coverage does Bronze Balm have?",
        "a": "It’s a sheer, buildable cream bronzer with a second-skin, satin finish that’s never cakey. It adds natural warmth and soft definition without orangeness or streaks."
      },
      {
        "q": "Can I use Bronze Balm for contouring?",
        "a": "Yes. Its oval stick makes it easy to use the narrow edge for soft sculpting and the wide side for all-over warmth."
      },
      {
        "q": "How do I choose my shade?",
        "a": "Match by The Minimalist shades: Quince (fair Ceramic–Dune), Clay (light Sandstone–Palomino), Seine (medium Sand–Calico), Leo (medium‑deep Amber–Tiger Eye), Monarch (deep Sepia–Bistre)."
      },
      {
        "q": "What are the key ingredients?",
        "a": "Vitamin E to condition and provide antioxidant care, octyldodecanol for smooth application, and fatty acids that condition skin and lock in moisture."
      },
      {
        "q": "Is Bronze Balm clean, vegan, and cruelty-free?",
        "a": "Yes. It’s Clean at MERIT and EU‑compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "What makes it beginner-friendly?",
        "a": "The lightweight, blendable formula is described as “impossible to mess up,” delivering a seamless, second-skin result."
      },
      {
        "q": "Is the packaging sustainable?",
        "a": "Yes. The component uses 43% recycled plastic and ships in FSC‑certified paper packaging."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 5,
    "sample_shades": [
      {
        "name": "Quince",
        "hex": "#C9996D"
      },
      {
        "name": "Clay",
        "hex": "#AC7F59"
      },
      {
        "name": "Seine",
        "hex": "#875F42"
      },
      {
        "name": "Leo",
        "hex": "#644332"
      }
    ],
    "all_shades": [
      {
        "id": 41665846149306,
        "name": "Quince",
        "hex": "#C9996D",
        "price": 32,
        "available": true,
        "sku": "M012-01-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/s2609725-hero_4ad44d1d-035f-47c7-8afb-b6afbcac774f.jpg?v=1706302155"
      },
      {
        "id": 41665846182074,
        "name": "Clay",
        "hex": "#AC7F59",
        "price": 32,
        "available": true,
        "sku": "M012-02-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-BronzerBalm-Clay_52eee416-4d66-4e3e-b28f-8a711af929c9.jpg?v=1754064167"
      },
      {
        "id": 41665846214842,
        "name": "Seine",
        "hex": "#875F42",
        "price": 32,
        "available": true,
        "sku": "M012-03-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-BronzeBalm-Seine_f959b4a1-622a-474c-a27b-fa28990f0d6a.jpg?v=1775147387"
      },
      {
        "id": 41665846247610,
        "name": "Leo",
        "hex": "#644332",
        "price": 32,
        "available": true,
        "sku": "M012-04-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-BronzeBalm-Leo_6495dabc-fb8e-4f61-97a9-44542bd33fba.jpg?v=1754405262"
      },
      {
        "id": 41665846280378,
        "name": "Monarch",
        "hex": "#331A08",
        "price": 32,
        "available": true,
        "sku": "M012-05-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/products/2609766-hero_1d4a241d-9c87-421d-b49e-3c2c41ce65e4.jpg?v=1744400718"
      }
    ]
  },
  "day-glow": {
    "handle": "day-glow",
    "title": "Day Glow",
    "subtitle": "Highlighting Balm",
    "short_description": "Highlighter made for daytime wear. This lightweight, moisturizing formula gives skin a dewy, lit-from-within glow — with zero sparkle.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "The vitamin-rich base replenishes moisture for a dewy, lit-from-within glow that lasts beyond makeup",
      "Microfine pearls reflect light and illuminate skin",
      "Plant-based squalane locks in hydration and gives a healthy-looking sheen",
      "A phytosterol and amino acid blend helps promote healthy skin barrier function",
      "Fragrance-free"
    ],
    "key_ingredients": [
      {
        "name": "Plant-Derived Squalane",
        "role": "Restorative Emollient",
        "benefit": "Replenishes moisture, restores suppleness, and locks in hydration without feeling greasy."
      },
      {
        "name": "Phytosterols & Olive Esters",
        "role": "Moisture Barrier Support",
        "benefit": "Nourishes the skin barrier and imparts a healthy, glass-like reflective sheen."
      }
    ],
    "how_to_use": [
      "Apply directly onto the cheekbones, brow bones, tip of the nose, and anywhere you want to add a dewy, balmy sheen",
      "Tap with your fingertips to blend"
    ],
    "faqs": [
      {
        "q": "What finish does Day Glow give?",
        "a": "A dewy, balmy sheen with zero sparkle for a lit-from-within glow."
      },
      {
        "q": "Does Day Glow contain glitter or shimmer?",
        "a": "No. It uses micro-fine pearls to reflect light without visible sparkle."
      },
      {
        "q": "Is Day Glow buildable and easy to blend?",
        "a": "Yes. The formula is sheer, buildable, and blendable for a natural, dewy finish."
      },
      {
        "q": "Which shades is Day Glow available in?",
        "a": "Bounce, Cava, Citrine, and Solstice."
      },
      {
        "q": "What skincare benefits or ingredients does it have?",
        "a": "A vitamin-rich base with plant-based squalane plus a phytosterol and amino acid blend to replenish moisture and support a healthy skin barrier."
      },
      {
        "q": "Is Day Glow clean, vegan, and cruelty-free?",
        "a": "Yes. It’s Clean at MERIT, EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "Is Day Glow designed for daytime wear?",
        "a": "Yes. It’s made for daytime to deliver a fresh, natural-looking glow."
      },
      {
        "q": "What packaging and sustainability standards does it meet?",
        "a": "It ships in our signature FSC-certified paper packaging, and MERIT is sustainability-focused."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 4,
    "sample_shades": [
      {
        "name": "Solstice",
        "hex": "#925847"
      },
      {
        "name": "Citrine",
        "hex": "#DDAC78"
      },
      {
        "name": "Cava",
        "hex": "#DEC3A8"
      },
      {
        "name": "Bounce",
        "hex": "#BC816E"
      }
    ],
    "all_shades": [
      {
        "id": 43415064608954,
        "name": "Solstice",
        "hex": "#925847",
        "price": 32,
        "available": true,
        "sku": "M008-05-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-DayGlow-Solstice_da958036-6279-40d6-a83d-bb3d8b05bf60.jpg?v=1736543149"
      },
      {
        "id": 41410395472058,
        "name": "Citrine",
        "hex": "#DDAC78",
        "price": 32,
        "available": true,
        "sku": "M008-03-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-DayGlow-Citrine_981a8f51-7072-4d92-b356-1e70c4d5396b.jpg?v=1750961679"
      },
      {
        "id": 36369087103133,
        "name": "Cava",
        "hex": "#DEC3A8",
        "price": 32,
        "available": true,
        "sku": "M008-01-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-DayGlow-Cava_7bfe9e94-3771-4313-b50e-9dd960bd562f.jpg?v=1754426509"
      },
      {
        "id": 36369087135901,
        "name": "Bounce",
        "hex": "#BC816E",
        "price": 32,
        "available": true,
        "sku": "M008-02-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-DayGlow-Bounce_b1b650b9-e46c-4483-8df5-130c71baa5d5.jpg?v=1745342331"
      }
    ]
  },
  "clean-lash": {
    "handle": "clean-lash",
    "title": "Clean Lash",
    "subtitle": "Lengthening Mascara",
    "short_description": "Your go-to mascara for every day. It tints, lengthens and defines lashes, with zero smudging — ever.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Proprietary tubing technology wraps and defines each lash with no smudging — ever",
      "Densely packed brush makes it easy to lift and separate each lash for a full, feathery look",
      "Fatty acids and olive oil esters condition lashes while vitamin B5 adds shine",
      "Removes easily with warm water and cleanser"
    ],
    "key_ingredients": [
      {
        "name": "Vitamin B5 (Panthenol)",
        "role": "Lash Conditioner & Humectant",
        "benefit": "Nourishes, hydrates, and strengthens lash fibers to resist breakage."
      },
      {
        "name": "Olive Oil Esters",
        "role": "Emollient Conditioning Agent",
        "benefit": "Softens lash hairs, ensuring lashes remain touchably soft and flexible rather than stiff."
      }
    ],
    "how_to_use": [
      "Comb through lashes from root to tip",
      "For added impact, build while lashes are still wet",
      "To remove, wash with warm water and cleanser"
    ],
    "faqs": [
      {
        "q": "What lash look does Clean Lash create?",
        "a": "It tints, lengthens and lifts for a natural, everyday effect with a full, feathery finish."
      },
      {
        "q": "Will Clean Lash smudge during the day?",
        "a": "No—our proprietary tubing technology wraps each lash with no smudging, ever."
      },
      {
        "q": "How do I remove Clean Lash?",
        "a": "It removes easily with warm water and a cleanser."
      },
      {
        "q": "Is the formula buildable?",
        "a": "Yes, Clean Lash is buildable for added definition while keeping lashes light and separated."
      },
      {
        "q": "What makes the brush different?",
        "a": "The precision brush lifts and separates each lash for a defined, fluttery look."
      },
      {
        "q": "Which ingredients care for my lashes?",
        "a": "Fatty acids and olive oil esters condition lashes, while vitamin B5 adds shine."
      },
      {
        "q": "Is Clean Lash clean, vegan, and cruelty-free?",
        "a": "Yes—it's Clean at MERIT and EU-compliant, and it's vegan and Leaping Bunny–certified."
      },
      {
        "q": "What sizes and shades are available?",
        "a": "Clean Lash comes in Full Size and Mini, with shades shown on the product page, including Black and Brown."
      },
      {
        "q": "Is the packaging sustainable?",
        "a": "Yes, it ships in MERIT’s signature FSC-certified paper packaging."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 3,
    "sample_shades": [
      {
        "name": "Perfect Black",
        "hex": "#000000"
      },
      {
        "name": "Brown",
        "hex": "#39251E"
      },
      {
        "name": "Mini",
        "hex": "#000000"
      }
    ],
    "all_shades": [
      {
        "id": 36369081761949,
        "name": "Perfect Black",
        "hex": "#000000",
        "price": 28,
        "available": true,
        "sku": "M004-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-CleanLash_d54570b8-8c0f-45e6-a399-35cc1296f1e2.jpg?v=1762550107"
      },
      {
        "id": 46048369180858,
        "name": "Brown",
        "hex": "#39251E",
        "price": 28,
        "available": true,
        "sku": "M004-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/CleanLash-Brown-Hero_82d44957-27b6-419d-90e6-4caeafc4b44d.jpg?v=1782329560"
      },
      {
        "id": 46062907162810,
        "name": "Mini",
        "hex": "#000000",
        "price": 16,
        "available": true,
        "sku": "M004-02-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/CleanLash-Travel-UncappedHero_893c3879-4b90-4431-aa93-24cf29310e0b.jpg?v=1782759351"
      }
    ]
  },
  "clean-volume": {
    "handle": "clean-volume",
    "title": "Clean Volume",
    "subtitle": "Volumizing Tubing Mascara",
    "short_description": "A lightweight tubing mascara that lifts and separates lashes for precise, buildable volume that lasts up to 16 hours. How to Use: Comb through lashes from root to tip. For added impact, build while lashes are still wet. To remove, wash with warm water and cleanser.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Creates customizable volume that wears for up to 16 hours without smudging or flaking",
      "Petite precision brush lifts and separates each lash for zero clumping",
      "Japanese-made tubing formula wraps each lash to lock in lift without heaviness",
      "Resists sweat, humidity, and water",
      "Removes easily with warm water and cleanser",
      "Ophthalmologist-tested and safe for sensitive eyes and contact lens wearers"
    ],
    "key_ingredients": [
      {
        "name": "Japanese Tubing Polymers (Acrylates Copolymer)",
        "role": "Tubing Film Former",
        "benefit": "Wraps each lash in water-resistant micro-tubes that lock in curl and volume without flaking or smudging."
      },
      {
        "name": "Carnauba Wax (Copernicia Cerifera)",
        "role": "Botanical Structuring Wax",
        "benefit": "Builds dense, flexible lash body and volume with lasting hold."
      },
      {
        "name": "Shea Butter (Butyrospermum Parkii)",
        "role": "Nourishing Emollient",
        "benefit": "Deeply conditions and softens lashes throughout 16 hours of continuous wear."
      }
    ],
    "how_to_use": [
      "Comb through lashes from root to tip",
      "For added impact, build while lashes are still wet",
      "To remove, wash with warm water and cleanser"
    ],
    "faqs": [
      {
        "q": "What does Clean Volume do for lashes?",
        "a": "It’s a lightweight tubing mascara that lifts and separates for precise, buildable volume that lasts up to 16 hours."
      },
      {
        "q": "Does Clean Volume smudge or flake during the day?",
        "a": "No—it wears up to 16 hours without smudging or flaking and resists sweat, humidity, and water."
      },
      {
        "q": "How do I remove Clean Volume?",
        "a": "Rinse with warm water and a cleanser; the tubing formula slides off without rubbing."
      },
      {
        "q": "Is Clean Volume safe for sensitive eyes and contact lens wearers?",
        "a": "Yes. It’s ophthalmologist-tested and safe for sensitive eyes and contact lenses."
      },
      {
        "q": "How should I apply it for the best results?",
        "a": "Comb from root to tip and build while lashes are still wet for added impact."
      },
      {
        "q": "Is the volume buildable without clumps?",
        "a": "Yes—the petite precision brush lifts and separates each lash for customizable volume with zero clumping."
      },
      {
        "q": "Will it hold a curl?",
        "a": "Yes. The Japanese-made tubing formula wraps each lash to lock in curl and lift without heaviness."
      },
      {
        "q": "What sizes are available?",
        "a": "Clean Volume is offered in Full Size and Mini."
      },
      {
        "q": "Is it clean, vegan, and cruelty-free?",
        "a": "Yes. It’s Clean at MERIT and EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "Is it waterproof?",
        "a": "It resists water, sweat, and humidity while still removing easily with warm water and a cleanser."
      }
    ],
    "shade_count": 3,
    "sample_shades": [
      {
        "name": "Black",
        "hex": "#000000"
      },
      {
        "name": "Brown",
        "hex": "#523935"
      },
      {
        "name": "Mini",
        "hex": "#000000"
      }
    ],
    "all_shades": [
      {
        "id": 45787782938810,
        "name": "Black",
        "hex": "#000000",
        "price": 28,
        "available": true,
        "sku": "M023-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/CleanVolume-Hero.jpg?v=1779981060"
      },
      {
        "id": 45787782971578,
        "name": "Brown",
        "hex": "#523935",
        "price": 28,
        "available": true,
        "sku": "M023-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/CleanVolume-Hero_fe406855-dc0c-41af-bf3b-ffd437627587.jpg?v=1779981544"
      },
      {
        "id": 46062705148090,
        "name": "Mini",
        "hex": "#000000",
        "price": 16,
        "available": true,
        "sku": "M023-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/CleanVolume-Travel-UncappedHero_1.jpg?v=1782755894"
      }
    ]
  },
  "solo-shadow": {
    "handle": "solo-shadow",
    "title": "Solo Shadow",
    "subtitle": "Eye Color",
    "short_description": "A buildable cream eyeshadow for a sheer wash of color — available in two finishes.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Provides a sheer, buildable wash of color with a soft matte finish",
      "Cream-to-powder formula blends in seamlessly without creasing or settling into fine lines",
      "Can be applied with your fingers or Brush No. 2 for more precision",
      "Rich in antioxidants and calming ingredients, chamomile and calendula extracts help nourish the eyelid",
      "Sunflower seed oil helps to nourish skin",
      "Ophthalmologist-tested and safe for sensitive eyes and contact lens wearers",
      "Provides a sheer wash of shiny, pearlescent color",
      "Blendable cream formula glides on effortlessly and sets to a smooth finish without settling into fine lines or wrinkles",
      "Wears comfortably for 12 hours with zero creasing, flaking or fallout",
      "Microfine pearls reflect light for a soft, multidimensional look"
    ],
    "key_ingredients": [
      {
        "name": "Chamomile & Calendula Extracts",
        "role": "Soothing Botanicals",
        "benefit": "Calm and comfort the delicate eyelid skin, preventing redness or sensitivity."
      },
      {
        "name": "Magnolia Bark Extract",
        "role": "Smoothing Antioxidant",
        "benefit": "Helps smooth the visual appearance of skin texture on the lids."
      },
      {
        "name": "Peptides",
        "role": "Fine Line Reducer",
        "benefit": "Help diminish the appearance of fine lines and creping on mature lids."
      },
      {
        "name": "Sunflower Seed Oil",
        "role": "Fatty Acid Rich Moisturizer",
        "benefit": "Nourishes the skin and prevents the cream-to-powder formula from drying out."
      }
    ],
    "how_to_use": [
      "For a sheer wash of color, swipe once across the eyelid",
      "Layer for added depth",
      "Blend using Brush No. 2 or your finger",
      "Twist tightly to seal",
      "For a sheer wash of color, tap once across the eyelid",
      "Build it up or layer on top of other shadows for added dimension"
    ],
    "faqs": [
      {
        "q": "What finishes does Solo Shadow come in?",
        "a": "Solo Shadow is available in two finishes: soft-matte (the Mattes) and shiny, pearlescent (the Sheens)."
      },
      {
        "q": "How do I apply Solo Shadow?",
        "a": "Swipe on with your fingers for a quick wash of color, or use Brush No. 2 for more precise placement and blending. Layer to build depth."
      },
      {
        "q": "Does Solo Shadow crease or have fallout?",
        "a": "The Mattes apply with a soft-matte finish without creasing or fallout, and the Sheens wear comfortably for 12 hours with zero creasing, flaking, or fallout."
      },
      {
        "q": "Is Solo Shadow safe for sensitive eyes and contact lens wearers?",
        "a": "Yes—it's ophthalmologist-tested and safe for sensitive eyes and contact lens wearers."
      },
      {
        "q": "Is Solo Shadow good for mature eyes?",
        "a": "Yes—the Sheens set to a smooth finish without settling into fine lines or wrinkles, and the Mattes have a smoothing formula with skin-loving ingredients."
      },
      {
        "q": "What skin-loving ingredients are in the formula?",
        "a": "The Mattes include chamomile and calendula extracts, magnolia bark extract, peptides, and sunflower seed oil."
      },
      {
        "q": "Is Solo Shadow vegan and cruelty-free?",
        "a": "Yes—it's Clean at MERIT + EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "Do I need a brush to use Solo Shadow?",
        "a": "No—fingers work beautifully, but Brush No. 2 can be used for added precision and blending."
      },
      {
        "q": "Has Solo Shadow won any awards?",
        "a": "Yes—the page features the Allure Best of Beauty Award Winner 2024 seal."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 14,
    "sample_shades": [
      {
        "name": "Studio",
        "hex": "#B68A7C"
      },
      {
        "name": "Vachetta",
        "hex": "#B38061"
      },
      {
        "name": "Midcentury",
        "hex": "#9C6D58"
      },
      {
        "name": "Brun",
        "hex": "#5C3724"
      }
    ],
    "all_shades": [
      {
        "id": 42532614242490,
        "name": "Studio",
        "hex": "#B68A7C",
        "price": 26,
        "available": true,
        "sku": "M013-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Studio_af61c3a7-cd02-4b8a-bce5-e4988aa75025.jpg?v=1761059779"
      },
      {
        "id": 42532614275258,
        "name": "Vachetta",
        "hex": "#B38061",
        "price": 26,
        "available": true,
        "sku": "M013-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Vachetta_a6e79ccc-f3d8-4eff-bc72-867d1c416b80.jpg?v=1761059779"
      },
      {
        "id": 42532614308026,
        "name": "Midcentury",
        "hex": "#9C6D58",
        "price": 26,
        "available": true,
        "sku": "M013-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Midcentury_66f8f734-6735-43d2-88b7-adb8ab38ef64.jpg?v=1761059779"
      },
      {
        "id": 42532614340794,
        "name": "Brun",
        "hex": "#5C3724",
        "price": 26,
        "available": true,
        "sku": "M013-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Brun_46d576af-d75f-4e31-8c53-ea041c3252f4.jpg?v=1761059779"
      },
      {
        "id": 42532614439098,
        "name": "Nelson",
        "hex": "#5F5049",
        "price": 26,
        "available": true,
        "sku": "M013-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Nelson.jpg?v=1761059779"
      },
      {
        "id": 42532614373562,
        "name": "Social",
        "hex": "#8D6F7B",
        "price": 26,
        "available": true,
        "sku": "M013-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Social_a0586f78-60fb-4ea7-9c3b-f3d118e3b80d.jpg?v=1761059779"
      },
      {
        "id": 45232150151354,
        "name": "Iris",
        "hex": "#916560",
        "price": 26,
        "available": true,
        "sku": "M022-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Iris_33785041-a0d3-405c-af5d-532be45d7d5a.jpg?v=1761075026"
      },
      {
        "id": 45232150184122,
        "name": "Glacé",
        "hex": "#D59A8B",
        "price": 26,
        "available": true,
        "sku": "M022-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Glace_1742c3c5-735c-4ca0-8c92-6f6ff151565a.jpg?v=1761059779"
      },
      {
        "id": 45232150216890,
        "name": "Matchbook",
        "hex": "#753732",
        "price": 26,
        "available": true,
        "sku": "M022-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Matchbook_197576e0-a50a-42eb-b8bc-207539e0934b.jpg?v=1761059779"
      },
      {
        "id": 45232150249658,
        "name": "Sartorial",
        "hex": "#7C5142",
        "price": 26,
        "available": true,
        "sku": "M022-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Sartorial_f67bba32-764e-49e1-bac1-33c13d9f8a83.jpg?v=1761059779"
      },
      {
        "id": 45232150282426,
        "name": "Palladium",
        "hex": "#D7B69F",
        "price": 26,
        "available": true,
        "sku": "M022-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Palladium.jpg?v=1761059779"
      },
      {
        "id": 45232150315194,
        "name": "Surrealism",
        "hex": "#DBA483",
        "price": 26,
        "available": true,
        "sku": "M022-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SoloShadowSheen-Hero-Surrealism.jpg?v=1769195077"
      },
      {
        "id": 42532614406330,
        "name": "Viper",
        "hex": "#555340",
        "price": 18.2,
        "available": true,
        "sku": "M013-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Viper.jpg?v=1761059779"
      },
      {
        "id": 42532614471866,
        "name": "Midnight",
        "hex": "#2F3357",
        "price": 18.2,
        "available": true,
        "sku": "M013-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SoloShadow-Midnight_418214d8-2ea7-4c70-b3be-73a196a61f39.jpg?v=1761059779"
      }
    ]
  },
  "signature-lip": {
    "handle": "signature-lip",
    "title": "Signature Lipstick",
    "subtitle": "Lightweight Lipstick",
    "short_description": "Comfortable color that’s so lightweight, you’ll forget you’re wearing it. This is lipstick you can live in.™",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Saturated, soft matte color that stays comfortable throughout the day",
      "Plush, velvet texture applies with a soft, blurred finish",
      "Hyaluronic acid helps hydrate lips so they look naturally plump",
      "Sesame seed extract smooths and conditions lips for comfort throughout the day",
      "Provides sheer, buildable color with a soft satin finish",
      "Applies without the heaviness of traditional lipstick",
      "Plant-derived squalane and sunflower seed oil are known to provide long-lasting moisture for a comfortable, light-as-air finish",
      "Vitamin C and papain enzyme help lips look healthy and smooth"
    ],
    "key_ingredients": [
      {
        "name": "Plant-Derived Squalane",
        "role": "Lightweight Emollient",
        "benefit": "Delivers deep moisture and restores supple softness to delicate lips."
      },
      {
        "name": "Vitamin C & Papain Enzyme",
        "role": "Antioxidant & Gentle Exfoliant",
        "benefit": "Brightens lip tone, protects against free radicals, and keeps lips looking smooth."
      },
      {
        "name": "Hyaluronic Acid & Sesame Seed Extract",
        "role": "Plumping Hydrator (in Matte shades)",
        "benefit": "Cushions lips with moisture for plush, comfortable all-day matte wear."
      }
    ],
    "how_to_use": [
      "Swipe directly onto lips for a sheer wash of color",
      "Layer for more saturated color",
      "Wear alone or paired with your favorite Signature Lip Liner or Shade Slick shade"
    ],
    "faqs": [
      {
        "q": "What finishes does Signature Lipstick come in?",
        "a": "Our Signature Lip Lightweight Lipstick is available in two finishes: a sheer satin and a soft, blurred matte."
      },
      {
        "q": "Is the color buildable?",
        "a": "Yes. One swipe gives a sheer wash; layer for more saturated color."
      },
      {
        "q": "Is Signature Lipstick vegan and cruelty-free?",
        "a": "Yes—it's Clean at MERIT, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "How can I make my lipstick look glossy?",
        "a": "Apply Shade Slick lip oil on top for a glossy finish."
      },
      {
        "q": "Can I pair this with a lip liner?",
        "a": "Yes. Use Signature Lip Liner for soft definition or sheer, all-over color."
      },
      {
        "q": "What shades are available?",
        "a": "Signature Lipstick comes in a range of satin and matte shades, from everyday neutrals to reds; see the shade carousel to view each on light, medium, and deep skin tones."
      },
      {
        "q": "What’s special about the packaging?",
        "a": "The component is made with 30% recycled plastic and ships in FSC-certified paper packaging."
      },
      {
        "q": "How does it wear throughout the day?",
        "a": "Both finishes are lightweight and comfortable; the matte delivers soft, saturated color that stays comfortable throughout the day."
      },
      {
        "q": "What is the price, and do you offer free shipping and returns?",
        "a": "MERIT offers free shipping and returns—see our Shipping & Orders page for details."
      }
    ],
    "shade_count": 16,
    "sample_shades": [
      {
        "name": "Bespoke",
        "hex": "#6B423C"
      },
      {
        "name": "Tiger",
        "hex": "#98321A"
      },
      {
        "name": "Baby",
        "hex": "#D98880"
      },
      {
        "name": "Millennial",
        "hex": "#E9989E"
      }
    ],
    "all_shades": [
      {
        "id": 45554858033338,
        "name": "Bespoke",
        "hex": "#6B423C",
        "price": 28,
        "available": true,
        "sku": "M011-11-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT_Signature_Lip_Bespoke_Hero.jpg?v=1769987396"
      },
      {
        "id": 40919496523962,
        "name": "Tiger",
        "hex": "#98321A",
        "price": 28,
        "available": false,
        "sku": "M011-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT_Signature_Lip_Tiger_Hero.jpg?v=1762552267"
      },
      {
        "id": 40919496392890,
        "name": "Baby",
        "hex": "#D98880",
        "price": 28,
        "available": true,
        "sku": "M011-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLip-Baby_08dd5d79-90ca-4a71-a994-91694a920b07.jpg?v=1762552267"
      },
      {
        "id": 40919496360122,
        "name": "Millennial",
        "hex": "#E9989E",
        "price": 28,
        "available": true,
        "sku": "M011-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLip-Millennial_c2ee36a9-dd95-43bc-bc0b-27b585b13540.jpg?v=1762552267"
      },
      {
        "id": 40919496491194,
        "name": "L'Avenue",
        "hex": "#A7413E",
        "price": 28,
        "available": true,
        "sku": "M011-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT_Signature_Lip_Lavenue_Hero.jpg?v=1762552267"
      },
      {
        "id": 40919496589498,
        "name": "1990",
        "hex": "#834D3B",
        "price": 28,
        "available": true,
        "sku": "M011-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLip-1990_be19e46f-5316-42a3-884b-76c92a0d7336.jpg?v=1762552267"
      },
      {
        "id": 43703443226810,
        "name": "Ginger",
        "hex": "#AF5346",
        "price": 28,
        "available": true,
        "sku": "M011-10-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SignatureLipSatin-Ginger-PDP_6af6e518-8eae-47a7-b0b3-23a81d2092b1.jpg?v=1762552267"
      },
      {
        "id": 43145258762426,
        "name": "Power",
        "hex": "#A11633",
        "price": 22.4,
        "available": true,
        "sku": "M015-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Power_424bec40-e794-4abc-8d58-a0cea051cd97.jpg?v=1762552267"
      },
      {
        "id": 43145258795194,
        "name": "Vermillion",
        "hex": "#B20317",
        "price": 22.4,
        "available": true,
        "sku": "M015-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Vermillion_4df989b8-476c-46b8-a0d7-e1b27e33a6d0.jpg?v=1762552267"
      },
      {
        "id": 43145258827962,
        "name": "Sunday",
        "hex": "#BF3F4E",
        "price": 22.4,
        "available": true,
        "sku": "M015-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Sunday_5be4ad0f-d23e-4272-9d0b-418d8c4f7a7c.jpg?v=1762552267"
      },
      {
        "id": 43145258893498,
        "name": "Antibes",
        "hex": "#914334",
        "price": 22.4,
        "available": true,
        "sku": "M015-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Antibes_67e033d8-eeba-4212-913f-6f9376ebc0b0.jpg?v=1762552267"
      },
      {
        "id": 43145258860730,
        "name": "Classic",
        "hex": "#AA5249",
        "price": 22.4,
        "available": true,
        "sku": "M015-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SignatureLipMatte-Classiccopy.jpg?v=1762552267"
      },
      {
        "id": 43145258696890,
        "name": "Maison",
        "hex": "#913E43",
        "price": 22.4,
        "available": false,
        "sku": "M015-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Maison_876005d1-2d0b-4374-bf2a-7cf6b287354d.jpg?v=1762552267"
      },
      {
        "id": 43145258664122,
        "name": "Equestrian",
        "hex": "#7B3128",
        "price": 22.4,
        "available": true,
        "sku": "M015-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Equestrian_76972f77-8a74-43f2-b431-f3b62d896087.jpg?v=1762552267"
      },
      {
        "id": 43145258729658,
        "name": "Court",
        "hex": "#A72328",
        "price": 22.4,
        "available": true,
        "sku": "M015-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-SigLipMatte-Court_90982ecb-b8a5-4dbb-ad41-6aefccf0e19b.jpg?v=1762552267"
      },
      {
        "id": 40919496327354,
        "name": "Slip",
        "hex": "#BB7E6A",
        "price": 28,
        "available": false,
        "sku": "M011-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT_Signature_Lip_Slip_Hero.jpg?v=1762552267"
      }
    ]
  },
  "signature-lip-blush": {
    "handle": "signature-lip-blush",
    "title": "Signature Lip Blush",
    "subtitle": "Lightweight Lip Blush",
    "short_description": "A sheer matte lightweight, buildable formula with a comfortable, balm-like feel. This is lipstick you can live in™",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Lightweight, buildable formula with a comfortable, balm-like feel",
      "Provides sheer matte color with a blurred, soft-focus finish",
      "Gel-wrapped pigments deliver smooth, even color and deep hydration",
      "Sesame-based active boosts hydration for visible smoother lips",
      "Safe for sensitive skin"
    ],
    "key_ingredients": [
      {
        "name": "Gel-Wrapped Pigments",
        "role": "Pigment Dispersion Matrix",
        "benefit": "Deliver smooth, streak-free blurred color while continuously releasing moisture."
      },
      {
        "name": "Sesame-Based Active",
        "role": "Hydration Booster",
        "benefit": "Boosts moisture retention for visibly smoother, softer, pillowy lips."
      },
      {
        "name": "Hydrogenated Olive Oil & Natural Waxes",
        "role": "Conditioning Emollient",
        "benefit": "Seals in hydration and prevents dryness without tacky or waxy weight."
      }
    ],
    "how_to_use": [
      "Swipe or dab onto lips for a subtle wash of color",
      "Layer for more saturated color",
      "Reapply throughout the day as needed",
      "Wear alone or paired with your favorite Signature Lip Liner"
    ],
    "faqs": [
      {
        "q": "What is MERIT’s Signature Lip Blush?",
        "a": "A lightweight, buildable lip color that delivers sheer matte pigment with a soft, blurred finish and a comfortable, balm-like feel."
      },
      {
        "q": "Is the color buildable?",
        "a": "Yes—apply a sheer wash and layer to increase pigment while maintaining a diffused, soft-focus look."
      },
      {
        "q": "How is Lip Blush different from MERIT’s Satin or Matte lip formulas?",
        "a": "Lip Blush gives sheer matte, blurred color; Satin offers sheer, hydrating color with a silky finish, while Matte delivers saturated color with a comfortable matte finish."
      },
      {
        "q": "Is it suitable for sensitive skin?",
        "a": "Yes, it’s safe for sensitive skin."
      },
      {
        "q": "What does it do for my lips?",
        "a": "Gel-wrapped pigments deliver smooth, even color, while a sesame-based active boosts hydration for visibly smoother lips."
      },
      {
        "q": "Is it vegan and cruelty-free?",
        "a": "Yes—it's vegan and Leaping Bunny–certified."
      },
      {
        "q": "Is it Clean at MERIT and EU-compliant?",
        "a": "Yes—Signature Lip Blush is Clean at MERIT and EU-compliant."
      },
      {
        "q": "Which shades does it come in?",
        "a": "Shades include Andie, Archival, Bespoke, Framboise, Gamay, Kitten Heel, September, and Vendôme"
      },
      {
        "q": "Can I get it in a set?",
        "a": "Yes—choose The Lip Blush Set (three shades) or The Lip Trio with Signature Lip Liner and Shade Slick."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 8,
    "sample_shades": [
      {
        "name": "Bespoke",
        "hex": "#6B423C"
      },
      {
        "name": "Vendôme",
        "hex": "#AB5E4C"
      },
      {
        "name": "Andie",
        "hex": "#D07177"
      },
      {
        "name": "Archival",
        "hex": "#A14F5B"
      }
    ],
    "all_shades": [
      {
        "id": 45424699211962,
        "name": "Bespoke",
        "hex": "#6B423C",
        "price": 28,
        "available": true,
        "sku": "M019-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-BESPOKE.jpg?v=1769984148"
      },
      {
        "id": 45424699244730,
        "name": "Vendôme",
        "hex": "#AB5E4C",
        "price": 28,
        "available": true,
        "sku": "M019-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-VENDOME_952bf6d4-8328-4574-aea9-57367c571c4a.jpg?v=1769984148"
      },
      {
        "id": 45424699277498,
        "name": "Andie",
        "hex": "#D07177",
        "price": 28,
        "available": true,
        "sku": "M019-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-ANDIE_002b2437-8e0c-41e8-87aa-ff7452106525.jpg?v=1769984148"
      },
      {
        "id": 45424699310266,
        "name": "Archival",
        "hex": "#A14F5B",
        "price": 28,
        "available": true,
        "sku": "M019-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-ARCHIVAL_ac0cb292-e418-48ab-ae26-dff7d62a2c3a.jpg?v=1769984148"
      },
      {
        "id": 45424699343034,
        "name": "Kitten Heel",
        "hex": "#D0473F",
        "price": 28,
        "available": true,
        "sku": "M019-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-KITTENHEEL_ce5403b2-bc7b-4576-a5a8-716f757c56e0.jpg?v=1769984148"
      },
      {
        "id": 45424699375802,
        "name": "Framboise",
        "hex": "#A93647",
        "price": 28,
        "available": true,
        "sku": "M019-09-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-FRAMBOISE_c7371392-b60e-4fcf-9808-462d12d34257.jpg?v=1769984148"
      },
      {
        "id": 45424699408570,
        "name": "September",
        "hex": "#9F2B2B",
        "price": 28,
        "available": true,
        "sku": "M019-10-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-SEPTEMBER_8a7582c6-2d2f-4b33-aaab-06b0377bdbcb.jpg?v=1769984148"
      },
      {
        "id": 45424699441338,
        "name": "Gamay",
        "hex": "#9D3B3A",
        "price": 28,
        "available": true,
        "sku": "M019-11-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SigLipBlush-Bullet-GAMAY_ccd10724-c19d-4a58-ae8d-7db9294baab8.jpg?v=1769984148"
      }
    ]
  },
  "signature-lip-liner": {
    "handle": "signature-lip-liner",
    "title": "Signature Lip Liner",
    "subtitle": "Sheer Liner",
    "short_description": "This hydrating, buildable lip pencil gives soft definition and sheer, all-over color that blends right in — no harsh lines, ever. It’s lip liner, finally made impossible to mess up.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Sheer, buildable color with a natural satin finish",
      "Smooth, lightweight gel formula glides on easily without crumbling or skipping",
      "Use it to create soft definition or all-over color",
      "Antioxidant-rich pomegranate and jojoba complex helps support skin barrier function for smooth, healthy looking lips",
      "Features a retractable tip and built-in sharpener for more precise application"
    ],
    "key_ingredients": [
      {
        "name": "Jojoba Oil Complex",
        "role": "Barrier Lipid Restorer",
        "benefit": "Supports the fragile lip barrier to prevent dehydration and chapping."
      },
      {
        "name": "Pomegranate Extract",
        "role": "Antioxidant Active",
        "benefit": "Protects lips against environmental stressors and promotes healthy lip tone."
      },
      {
        "name": "Jojoba Complex",
        "role": "Supports skin barrier function for smooth",
        "benefit": "Supports skin barrier function for smooth, healthy looking lips."
      }
    ],
    "how_to_use": [
      "Apply along the lip line to create soft definition or all over for a sheer wash of color",
      "Layer for more intensity",
      "Wear alone or paired with your favorite Signature Lip or Shade Slick shade"
    ],
    "faqs": [
      {
        "q": "Is Signature Lip Liner sheer or matte?",
        "a": "It provides sheer, buildable color with a natural satin finish."
      },
      {
        "q": "Can I use it all over my lips or just to line?",
        "a": "Both—apply along the lip line for soft definition or fill in for a sheer wash of color, then layer for more intensity."
      },
      {
        "q": "Is the formula hydrating?",
        "a": "Yes. The lightweight gel is infused with a jojoba complex and antioxidant-rich pomegranate to keep lips soft and comfortable."
      },
      {
        "q": "Will it tug or crumble when I apply it?",
        "a": "No. The smooth, lightweight gel formula glides on without tugging, skipping, or crumbling."
      },
      {
        "q": "Does it have a retractable tip and sharpener?",
        "a": "Yes. It features a retractable tip and a built-in sharpener for precise application."
      },
      {
        "q": "What shades does it come in?",
        "a": "Eight ultra-wearable neutrals: Beverly Hills (soft peach pink), Sportif (warm peach brown), Coupé (cool pink), Mayfair (cool mauve), Bespoke (rose brown), Tabac (neutral brown), Brownstone (warm brown), and Capricorn (rich brown)."
      },
      {
        "q": "How do I pair it with other MERIT lip products?",
        "a": "Wear it alone or layer with your favorite Signature Lip or Shade Slick shade for an easy, everyday lip"
      },
      {
        "q": "What are the key skincare-style ingredients?",
        "a": "A jojoba complex to support the skin barrier and antioxidant-rich pomegranate for smooth, healthy-looking lips."
      },
      {
        "q": "Is it clean, vegan, and cruelty-free?",
        "a": "Yes. It’s Clean at MERIT and EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 14,
    "sample_shades": [
      {
        "name": "Rose",
        "hex": "#DF9597"
      },
      {
        "name": "June",
        "hex": "#C68B7D"
      },
      {
        "name": "Cassis",
        "hex": "#B75157"
      },
      {
        "name": "Subconscious",
        "hex": "#AC6068"
      }
    ],
    "all_shades": [
      {
        "id": 45827285352634,
        "name": "Rose",
        "hex": "#DF9597",
        "price": 24,
        "available": true,
        "sku": "M017-12-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-Rose-Soldier.jpg?v=1777987137"
      },
      {
        "id": 45827285385402,
        "name": "June",
        "hex": "#C68B7D",
        "price": 24,
        "available": true,
        "sku": "M017-13-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-June-Soldier.jpg?v=1777987166"
      },
      {
        "id": 45827285319866,
        "name": "Cassis",
        "hex": "#B75157",
        "price": 24,
        "available": true,
        "sku": "M017-14-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-Cassis-Soldier_f3b84c1b-b075-407b-8ff0-9a813a645282.jpg?v=1777987122"
      },
      {
        "id": 45827285287098,
        "name": "Subconscious",
        "hex": "#AC6068",
        "price": 24,
        "available": true,
        "sku": "M017-15-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-Cassis-Soldier.jpg?v=1777987071"
      },
      {
        "id": 45827285418170,
        "name": "Cowboy",
        "hex": "#915E51",
        "price": 24,
        "available": true,
        "sku": "M017-16-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-Cowboy-Soldier.jpg?v=1777987181"
      },
      {
        "id": 45827285450938,
        "name": "Bauhaus",
        "hex": "#814C5E",
        "price": 24,
        "available": true,
        "sku": "M017-17-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-SignatureLipLiner-Bauhaus-Soldier.jpg?v=1777987227"
      },
      {
        "id": 44435757793466,
        "name": "Bespoke",
        "hex": "#a06e6f",
        "price": 24,
        "available": true,
        "sku": "M017-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Bespoke-Soldier_36e6b453-9dcf-40af-b43d-aa4975d15a76.jpg?v=1775253493"
      },
      {
        "id": 44435757826234,
        "name": "Coupé",
        "hex": "#ba8385",
        "price": 24,
        "available": true,
        "sku": "M017-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Coupe-Soldier_146d4d26-7bbf-4c49-a304-197ccfea2fee.jpg?v=1753796488"
      },
      {
        "id": 44435757760698,
        "name": "Beverly Hills",
        "hex": "#cf9d94",
        "price": 24,
        "available": true,
        "sku": "M017-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-BeverlyHills-Soldier_19e36dae-e48d-459b-a175-3b84640cf210.jpg?v=1754426509"
      },
      {
        "id": 44435757859002,
        "name": "Sportif",
        "hex": "#884a2e",
        "price": 24,
        "available": true,
        "sku": "M017-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Sportif-Soldier_a9369a3f-e028-442b-a933-bc6e6e37d8bb.jpg?v=1744400607"
      },
      {
        "id": 44435757891770,
        "name": "Mayfair",
        "hex": "#a4676e",
        "price": 24,
        "available": true,
        "sku": "M017-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Mayfair-Soldier_66bfa50e-66d6-4652-a345-71e6846871cf.jpg?v=1769195026"
      },
      {
        "id": 44435757957306,
        "name": "Brownstone",
        "hex": "#795148",
        "price": 24,
        "available": true,
        "sku": "M017-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Brownstone-Soldier_d610b8cd-0ef5-42a6-91a9-e8028f137474.jpg?v=1744400616"
      },
      {
        "id": 44435757924538,
        "name": "Tabac",
        "hex": "#8e645a",
        "price": 16.8,
        "available": true,
        "sku": "M017-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Tabac-Soldier_363a7381-f4a1-4bba-94af-7188d77a8c2f.jpg?v=1744400611"
      },
      {
        "id": 44435757990074,
        "name": "Capricorn",
        "hex": "#674e40",
        "price": 16.8,
        "available": true,
        "sku": "M017-09-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-SignatureLipLiner-Capricorn-Soldier_eaf6f76f-5a37-4a3b-af03-9e2b68b368f2.jpg?v=1744400615"
      }
    ]
  },
  "shade-slick": {
    "handle": "shade-slick",
    "title": "Shade Slick",
    "subtitle": "Tinted Lip Oil",
    "short_description": "A lightweight tinted lip oil gives a wash of moisturizing color for healthy lips all day.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Cushioned formula gives a wash of lightly pigmented color with a pearlescent finish",
      "Glides on smooth and wears comfortably throughout the day with zero stickiness",
      "Plant-derived squalane moisturizes lips and helps restore suppleness",
      "Quinoa seed oil supports barrier function to help protect against environmental aggressors",
      "Provides sheer, buildable color with a high-shine, never sticky finish",
      "Rosehip oil, rich in omega-3 fatty acids, helps support healthy skin barrier function",
      "Shea butter and grapeseed oils help replenish, condition and soften lips",
      "Moisturizing jojoba oil creates a protective barrier to help lock in moisture",
      "Provides a hint of color for a glossy, bare-lip finish",
      "Blooming pigments work with your lips' natural pH and color to create a subtle stain that looks a little different on everyone"
    ],
    "key_ingredients": [
      {
        "name": "Plant-Derived Squalane",
        "role": "Moisture Restorer",
        "benefit": "Restores suppleness and seals hydration into the lips without greasiness."
      },
      {
        "name": "Quinoa Seed Oil",
        "role": "Protective Barrier Oil",
        "benefit": "Supports barrier function and shields lips from environmental drying."
      },
      {
        "name": "Rosehip, Jojoba & Grapeseed Oils",
        "role": "Omega-Rich Botanical Oils",
        "benefit": "Replenish essential fatty acids to condition, soften, and soothe chapped lips."
      },
      {
        "name": "Chamomile and calendula extracts",
        "role": "help to soothe the lip area",
        "benefit": "help to soothe the lip area"
      },
      {
        "name": "Magnolia bark extract",
        "role": "helps to smooth the appearance of skin",
        "benefit": "helps to smooth the appearance of skin"
      },
      {
        "name": "Peptides",
        "role": "help to reduce the appearance of fine lines",
        "benefit": "help to reduce the appearance of fine lines"
      },
      {
        "name": "Sunflower seed oil",
        "role": "helps to nourish skin",
        "benefit": "helps to nourish skin"
      }
    ],
    "how_to_use": [
      "Swipe onto lips for a sheer wash of color and moisture",
      "Wear alone or paired with your favorite Signature Lip Liner shade"
    ],
    "faqs": [
      {
        "q": "What is Shade Slick and what finish does it provide?",
        "a": "Shade Slick is MERIT’s tinted lip oil that gives a wash of moisturizing color with a high-shine finish, now also available in a new pearlescent Sheen."
      },
      {
        "q": "What’s the difference between The Sheens, The Classics, and The Gelées?",
        "a": "The Sheens are cushioned, lightly pigmented, pearlescent, and wear longer with zero stickiness. The Classics have the most pigment with buildable, glossy color. The Gelées are the sheerest with pH-reactive pigments that create a subtle stain and a bare-lip look."
      },
      {
        "q": "Is Shade Slick sticky or heavy?",
        "a": "The Sheens glide on smooth and wear comfortably with zero stickiness, and all finishes feel lightweight and glossy."
      },
      {
        "q": "What ingredients make Shade Slick moisturizing?",
        "a": "Key hydrators include plant-derived squalane and quinoa seed oil, while The Classics also feature rosehip oil, shea butter, grapeseed oil, and jojoba oil."
      },
      {
        "q": "How should I wear it with lip liner?",
        "a": "Pair it with MERIT’s Signature Lip Liner—line first, then finish with Shade Slick Sheen for an easy everyday lip duo."
      },
      {
        "q": "Is it clean, vegan, and cruelty-free?",
        "a": "Yes. It’s Clean at MERIT and EU-compliant, vegan, and Leaping Bunny–certified."
      },
      {
        "q": "How long does it wear?",
        "a": "The Sheens have an updated formula for more cushion and longer wear while remaining comfortable throughout the day."
      },
      {
        "q": "Do you offer free shipping and returns?",
        "a": "Yes. See our Shipping & Orders page for details."
      }
    ],
    "shade_count": 12,
    "sample_shades": [
      {
        "name": "Jeté",
        "hex": "#D46551"
      },
      {
        "name": "Les Deux",
        "hex": "#E11F4D"
      },
      {
        "name": "Maraschino",
        "hex": "#D32128"
      },
      {
        "name": "Mapleton",
        "hex": "#95212E"
      }
    ],
    "all_shades": [
      {
        "id": 42361598738618,
        "name": "Jeté",
        "hex": "#D46551",
        "price": 19.2,
        "available": true,
        "sku": "M016-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Gelees-Jete_2da97d51-1afe-4f43-9c81-b8063d6741d1.jpg?v=1754064166"
      },
      {
        "id": 42361598705850,
        "name": "Les Deux",
        "hex": "#E11F4D",
        "price": 19.2,
        "available": true,
        "sku": "M016-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Gelees-LesDeux_5de036b4-f0a0-4ade-bf3e-f356d6d3b8c4.jpg?v=1750195718"
      },
      {
        "id": 42361598771386,
        "name": "Maraschino",
        "hex": "#D32128",
        "price": 19.2,
        "available": true,
        "sku": "M016-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-ShadeSlickGelees-Maraschino_8f8aa5e4-7330-416c-a494-5a0129b54b01.jpg?v=1723837938"
      },
      {
        "id": 42361598804154,
        "name": "Mapleton",
        "hex": "#95212E",
        "price": 19.2,
        "available": true,
        "sku": "M016-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Gelees_Mapleton_Bottle_9ac174b4-2449-4366-bff2-fdd022029519.jpg?v=1751488466"
      },
      {
        "id": 40322814214330,
        "name": "Taupe",
        "hex": "#CA896D",
        "price": 19.2,
        "available": true,
        "sku": "M002-07-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Merit-ShadeSlick-Taupe-01_f480e962-91b1-4b65-b8f3-b18842eaaa4a.jpg?v=1752093201"
      },
      {
        "id": 36369093853341,
        "name": "Marrakech",
        "hex": "#A8523E",
        "price": 19.2,
        "available": true,
        "sku": "M002-02-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Merit-ShadeSlick-Marrakech-01_b78dca65-ffa6-4f8b-94e9-3c52c8c268cf.jpg?v=1723127630"
      },
      {
        "id": 36369093951645,
        "name": "Sangria",
        "hex": "#6B2606",
        "price": 19.2,
        "available": true,
        "sku": "M002-04-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Merit-ShadeSlick-Sangria-01_e497b67c-47dc-452a-8fce-12ca0c6f103c.jpg?v=1726085731"
      },
      {
        "id": 44719220162746,
        "name": "Tabby",
        "hex": "#633125",
        "price": 19.2,
        "available": false,
        "sku": "M016-08-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-ShadeSlickSheen-Tabby-Soldier.jpg?v=1766021043"
      },
      {
        "id": 36369093918877,
        "name": "Pink Beet",
        "hex": "#A94E49",
        "price": 19.2,
        "available": true,
        "sku": "M002-03-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Merit-Shade_20Slick-Pink_20Beet-01_6bef6624-a4c9-4c55-bd62-052ae4e7e609.jpg?v=1744400568"
      },
      {
        "id": 44719220064442,
        "name": "Pointelle",
        "hex": "#AF5452",
        "price": 19.2,
        "available": false,
        "sku": "M016-05-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-ShadeSlickSheen-Pointelle-Soldier_a6df066b-26a9-4914-963a-1d81b2672528.jpg?v=1749057361"
      },
      {
        "id": 44719220097210,
        "name": "Biarritz",
        "hex": "#AF5948",
        "price": 19.2,
        "available": true,
        "sku": "M016-06-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-ShadeSlickSheen-Biarritz-Soldier_3404dd22-fc1d-44ab-9bc3-ceaea6ba8513.jpg?v=1754947236"
      },
      {
        "id": 44719220129978,
        "name": "Twin Set",
        "hex": "#94494A",
        "price": 19.2,
        "available": false,
        "sku": "M016-07-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT25-ShadeSlickSheen-TwinSet-Soldier_d3d42183-d6a2-4a78-b5dd-20275ed91266.jpg?v=1757016638"
      }
    ]
  },
  "brow-1980": {
    "handle": "brow-1980",
    "title": "Brow 1980",
    "subtitle": "Volumizing Pomade",
    "short_description": "A nod to the brows of the ‘80s, this volumizing pomade gives you soft, fluffy brows with light hold and zero crunchiness.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Adds color and volume for fluffy, natural-looking brows",
      "Shapes and grooms brows into place with flexible, all-day hold",
      "Nourishing vitamin B5 conditions and strengthens brows",
      "Kaolin clay and mineral pigments build natural-looking color",
      "Tapered precision brush makes it easy to coat every hair"
    ],
    "key_ingredients": [
      {
        "name": "Panthenol (Provitamin B5)",
        "role": "Hair Conditioner & Humectant",
        "benefit": "Conditions, softens, and nourishes brow hairs with each application."
      },
      {
        "name": "Kaolin Clay & Mineral Pigments",
        "role": "Volumizing Texturizer",
        "benefit": "Gently clings to individual hairs to create full, natural-looking fullness and depth."
      },
      {
        "name": "Carnauba Wax",
        "role": "Botanical Styling Wax",
        "benefit": "Provides flexible styling hold and healthy natural sheen without stiffness."
      }
    ],
    "how_to_use": [
      "Coat brows — starting from the outside and moving in to add volume — then brush up and out to shape",
      "Follow with Brow 1990 to fill in any gaps"
    ],
    "faqs": [
      {
        "q": "What does Brow 1980 do?",
        "a": "It adds color and volume for fluffy, natural-looking brows and helps shape and groom with a light, flexible, lasting hold and zero crunchiness."
      },
      {
        "q": "How do I use Brow 1980?",
        "a": "Coat brows starting from the outside and moving in to add volume, then brush up and out to shape. For extra definition, follow with Brow 1990 to fill any gaps."
      },
      {
        "q": "What finish and hold does it provide?",
        "a": "A soft, fluffy, natural-looking finish with light, flexible hold and zero crunchiness."
      },
      {
        "q": "Which shades does it come in?",
        "a": "Four shades: Taupe (cool blonde), Light Brown (neutral brown), Dark Brown (warm brown), and Brown Black (soft black)."
      },
      {
        "q": "What are the key ingredients and benefits?",
        "a": "Panthenol (provitamin B5) helps condition brows; kaolin clay and mineral pigments build natural-looking color; carnauba wax adds thickness and shine."
      },
      {
        "q": "Can I use it alone or with other brow products?",
        "a": "Use Brow 1980 on its own or pair it with Brow 1990 to fill and define."
      },
      {
        "q": "Is MERIT cruelty-free?",
        "a": "Yes. MERIT is Vegan and Leaping Bunny–certified."
      },
      {
        "q": "What size is it now, and how is it packaged?",
        "a": "Brow 1980 now comes in bigger packaging with 4.5g of product (formerly 2.4g) and ships in our signature FSC-certified paper packaging."
      },
      {
        "q": "Can I buy it in a set?",
        "a": "Yes—the Brow Duo pairs Brow 1980 with our Brow 1990 pencil for less, and The Eye Set bundles eye essentials."
      }
    ],
    "shade_count": 4,
    "sample_shades": [
      {
        "name": "Taupe",
        "hex": "#876b5c"
      },
      {
        "name": "Light Brown",
        "hex": "#6e5349"
      },
      {
        "name": "Dark Brown",
        "hex": "#483834"
      },
      {
        "name": "Brown Black",
        "hex": "#312c29"
      }
    ],
    "all_shades": [
      {
        "id": 43975772373178,
        "name": "Taupe",
        "hex": "#876b5c",
        "price": 24,
        "available": true,
        "sku": "M005-01-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1980-Soldier-Taupe.jpg?v=1749758538"
      },
      {
        "id": 43975772405946,
        "name": "Light Brown",
        "hex": "#6e5349",
        "price": 24,
        "available": true,
        "sku": "M005-02-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1980-Soldier-LightBrown.jpg?v=1749758538"
      },
      {
        "id": 43975772438714,
        "name": "Dark Brown",
        "hex": "#483834",
        "price": 24,
        "available": true,
        "sku": "M005-05-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1980-Soldier-DarkBrown.jpg?v=1749758538"
      },
      {
        "id": 43975772471482,
        "name": "Brown Black",
        "hex": "#312c29",
        "price": 24,
        "available": true,
        "sku": "M005-03-0001",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Brow1980_75ed62b5-8a94-4b6b-9d64-c90dd6ab9cfa.jpg?v=1756233780"
      }
    ]
  },
  "brow-1990": {
    "handle": "brow-1990",
    "title": "Brow 1990",
    "subtitle": "Sheer Gel Pencil",
    "short_description": "This microfine gel pencil fills and defines brows for soft, natural-looking fullness. It’s not revolutionary — but it is really good. See Full Details",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Ultra-fine pencil creates soft strokes to add natural-looking fullness and definition",
      "Soft gel formula applies smoothly without tugging or pulling on delicate skin",
      "For the best results, roll the pencil up no more than 1 mm and apply using gentle strokes to prevent breakage.",
      "Sunflower oil is rich in nourishing vitamin E and known to provide lightweight moisture",
      "Safflower extract is known to encourage softer, more supple hair.",
      "Hibiscus flower extract is rich in amino acids to help condition hair"
    ],
    "key_ingredients": [
      {
        "name": "Sunflower Seed Oil",
        "role": "Lightweight Conditioning Oil",
        "benefit": "Rich in vitamin E, delivers featherlight moisture so the gel pencil glides smoothly."
      },
      {
        "name": "Safflower Extract",
        "role": "Hair Softener",
        "benefit": "Encourages softer, more supple brow hair texture over time."
      },
      {
        "name": "Hibiscus Flower Extract",
        "role": "Amino Acid Complex",
        "benefit": "Rich in conditioning amino acids that support healthy hair appearance."
      }
    ],
    "how_to_use": [
      "Roll pencil up no more than 1 mm to prevent breakage.",
      "Use light, flicking upward strokes in sparse areas to mimic natural brow hairs.",
      "Apply Brow 1980 first for volume and hold, then detail with Brow 1990 for precision.",
      "Use the built-in spoolie to diffuse lines for a soft, realistic finish."
    ],
    "faqs": [
      {
        "q": "What is Brow 1990 and what does it do?",
        "a": "Brow 1990 is a microfine gel pencil that fills and defines brows with ultra-fine, hair-like strokes for soft, natural-looking fullness."
      },
      {
        "q": "How do I apply Brow 1990 without breaking the pencil?",
        "a": "For best results, twist the pencil up no more than 1 mm and apply using gentle, featherlight flicking strokes to mimic natural brow hairs."
      },
      {
        "q": "Can Brow 1990 be paired with Brow 1980?",
        "a": "Yes—apply Brow 1980 first to create volume and flexible hold, then use Brow 1990’s precise microfine tip to fill in sparse gaps and define arches."
      },
      {
        "q": "What shades does Brow 1990 come in?",
        "a": "Brow 1990 is available in four natural shades: Taupe (cool blonde), Light Brown (neutral brown), Dark Brown (warm brown), and Brown-Black (soft black)."
      },
      {
        "q": "What nourishing ingredients are in Brow 1990?",
        "a": "The formula is infused with vitamin E-rich sunflower oil for smooth glide, safflower extract to encourage softer hair, and hibiscus flower extract rich in amino acids to condition."
      },
      {
        "q": "Is Brow 1990 vegan and cruelty-free?",
        "a": "Yes. Brow 1990 is Clean at MERIT, EU-compliant, vegan, and Leaping Bunny certified cruelty-free."
      }
    ],
    "shade_count": 4,
    "sample_shades": [
      {
        "name": "Taupe",
        "hex": "#876b5c"
      },
      {
        "name": "Light Brown",
        "hex": "#6e5349"
      },
      {
        "name": "Dark Brown",
        "hex": "#483834"
      },
      {
        "name": "Brown-Black",
        "hex": "#312c29"
      }
    ],
    "all_shades": [
      {
        "id": 43842531492026,
        "name": "Taupe",
        "hex": "#876b5c",
        "price": 24,
        "available": true,
        "sku": "M018-01-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1990-Solider-Taupe.jpg?v=1744400659"
      },
      {
        "id": 43842531524794,
        "name": "Light Brown",
        "hex": "#6e5349",
        "price": 24,
        "available": true,
        "sku": "M018-02-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1990-Solider-LightBrown_0bf82487-3f17-4d07-bb60-e0d8869f0f5f.jpg?v=1744400659"
      },
      {
        "id": 43842531590330,
        "name": "Dark Brown",
        "hex": "#483834",
        "price": 24,
        "available": true,
        "sku": "M018-04-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/Brow-1990-Solider-DarkBrown_f63e8815-36da-4968-871e-84b4a2171d81.jpg?v=1726178286"
      },
      {
        "id": 43842531557562,
        "name": "Brown-Black",
        "hex": "#312c29",
        "price": 24,
        "available": true,
        "sku": "M018-03-0000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-Brow1990_4ad7d234-d812-430d-8b79-88afa782087f.jpg?v=1756233779"
      }
    ]
  },
  "the-uniform-spf-45": {
    "handle": "the-uniform-spf-45",
    "title": "The Uniform",
    "subtitle": "Tinted Mineral Sunscreen SPF 45",
    "short_description": "A mineral sunscreen that provides broad spectrum UVA/UVB protection and a sheer tint that blends in with a light-as-air finish. It’s a sunscreen so perfect, you’ll actually want to wear it every day.",
    "finish": "",
    "coverage": "",
    "formula_highlights": [
      "Lightweight, buildable formula blends effortlessly into skin",
      "Gives sheer coverage with a natural, soft-focus finish",
      "15% non-nano zinc oxide provides physical broad spectrum (UVA/UVB) protection while minimizing white cast",
      "Fine natural powders blur, smooth and even the look of skin with a soft, velvety finish",
      "True-to-tone pigments in a lightweight emollient base deliver smooth, blendable coverage",
      "Ideal for normal, combination, and oily skin types",
      "Non-comedogenic, oil-free and made without silicones",
      "Dermatologist-tested",
      "Skin Cancer Foundation Seal of Recommendation"
    ],
    "key_ingredients": [
      {
        "name": "Non-Nano Zinc Oxide (15.065%)",
        "role": "Physical Mineral UV Filter",
        "benefit": "Provides broad-spectrum UVA/UVB SPF 45 protection while minimizing white cast."
      },
      {
        "name": "Zea Mays (Corn) Starch & Micro Powders",
        "role": "Soft-Focus Blurring Powders",
        "benefit": "Absorbs excess sebum, smooths uneven texture, and leaves a velvety finish."
      },
      {
        "name": "C13-15 Alkane & Isoamyl Laurate",
        "role": "Clean Plant-Derived Emollients",
        "benefit": "Provide a featherlight slip for seamless blending without clogging pores or feeling greasy."
      }
    ],
    "how_to_use": [
      "Apply it after Great Skin Priming Moisturizer as the final step in your skincare routine",
      "Apply generously 15 minutes before sun exposure",
      "Reapply every two hours and directly after any physical activity or exposure to water",
      "Follow with The Minimalist for additional coverage"
    ],
    "faqs": [
      {
        "q": "What level of sun protection does The Uniform provide?",
        "a": "Broad spectrum SPF 45 using 15% non-nano zinc oxide for UVA/UVB protection."
      },
      {
        "q": "What skin types is it best for?",
        "a": "It’s ideal for normal, combination, and oily skin, and is non-comedogenic, oil-free, silicone-free, and dermatologist-tested."
      },
      {
        "q": "What kind of coverage and finish can I expect?",
        "a": "Sheer, buildable coverage with a soft-focus, natural, light-as-air finish that helps blur and even the look of skin."
      },
      {
        "q": "Can I wear it under makeup?",
        "a": "Yes—The Uniform layers smoothly, and 100% of users in our study agreed it works well under makeup."
      },
      {
        "q": "How many shades does it come in, and how do I find mine?",
        "a": "20 sheer shades designed to blend seamlessly; use our Shade Finder and 30-Day Shade Match Promise."
      },
      {
        "q": "Is it vegan and cruelty-free?",
        "a": "Yes—MERIT is vegan and Leaping Bunny–certified."
      },
      {
        "q": "Does it have the Skin Cancer Foundation Seal?",
        "a": "Yes, The Uniform holds the Skin Cancer Foundation Seal of Recommendation."
      },
      {
        "q": "Is it easy to reapply during the day?",
        "a": "Yes—users agreed it’s easy to reapply and feels light as air on skin."
      }
    ],
    "shade_count": 20,
    "sample_shades": [
      {
        "name": "02",
        "hex": "#41281B"
      },
      {
        "name": "03",
        "hex": "#461B0A"
      },
      {
        "name": "04",
        "hex": "#5F3420"
      },
      {
        "name": "06",
        "hex": "#794A2B"
      }
    ],
    "all_shades": [
      {
        "id": 44831033131194,
        "name": "02",
        "hex": "#41281B",
        "price": 38,
        "available": true,
        "sku": "M021-US-0200",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-02_0e6a0e65-0d24-4aea-ba95-79a3a60b2516.jpg?v=1753457474"
      },
      {
        "id": 45762207744186,
        "name": "03",
        "hex": "#461B0A",
        "price": 38,
        "available": true,
        "sku": "M021-US-0300",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-TheUniform-Soldier-US-3_b62e6145-9920-49bc-91a9-e777890f4402.jpg?v=1775654677"
      },
      {
        "id": 44831033163962,
        "name": "04",
        "hex": "#5F3420",
        "price": 38,
        "available": true,
        "sku": "M021-US-0400",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-04_f8592607-23a6-4f0f-9975-32f42198d621.jpg?v=1747836288"
      },
      {
        "id": 44831033196730,
        "name": "06",
        "hex": "#794A2B",
        "price": 38,
        "available": true,
        "sku": "M021-US-0600",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-06_0aa7dbdc-79a7-443c-90c9-4a20dde8e80c.jpg?v=1747836289"
      },
      {
        "id": 44831033229498,
        "name": "08",
        "hex": "#8C4F38",
        "price": 38,
        "available": true,
        "sku": "M021-US-0800",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-08_afca3e62-f71d-40b7-b5f9-40363f3934f3.jpg?v=1747836290"
      },
      {
        "id": 44831033262266,
        "name": "10",
        "hex": "#9A592B",
        "price": 38,
        "available": true,
        "sku": "M021-US-1000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-10_439e707a-48eb-49fc-b7f1-cf6b42671f1e.jpg?v=1747836291"
      },
      {
        "id": 44831033295034,
        "name": "12",
        "hex": "#B77340",
        "price": 38,
        "available": true,
        "sku": "M021-US-1200",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-12_53c07a6a-65ca-4027-897a-3c7355272181.jpg?v=1747836292"
      },
      {
        "id": 44831033327802,
        "name": "14",
        "hex": "#C0874F",
        "price": 38,
        "available": true,
        "sku": "M021-US-1400",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-14_c60d8d7f-d0ca-4561-94b5-0c13c47be4b8.jpg?v=1747836293"
      },
      {
        "id": 45762207776954,
        "name": "15",
        "hex": "#BA7A56",
        "price": 38,
        "available": true,
        "sku": "M021-US-1500",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-TheUniform-Soldier-US-15_07cacf1e-0216-47a6-b347-077476a18fcf.jpg?v=1775654710"
      },
      {
        "id": 44831033360570,
        "name": "16",
        "hex": "#CE8961",
        "price": 38,
        "available": true,
        "sku": "M021-US-1600",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-16_2f797516-9be9-4171-97ff-d7ec5090f7d0.jpg?v=1747836294"
      },
      {
        "id": 44831033393338,
        "name": "18",
        "hex": "#D89A64",
        "price": 38,
        "available": true,
        "sku": "M021-US-1800",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-18_9e746751-ebe7-49c7-a563-cbcd0b463dc8.jpg?v=1747836294"
      },
      {
        "id": 44831033426106,
        "name": "20",
        "hex": "#DDA16F",
        "price": 38,
        "available": true,
        "sku": "M021-US-2000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-20_45000c6f-0dff-4381-8bf4-c0856b9c579e.jpg?v=1750958722"
      },
      {
        "id": 45762207809722,
        "name": "21",
        "hex": "#E5A371",
        "price": 38,
        "available": true,
        "sku": "M021-US-2100",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-TheUniform-Soldier-US-21_8bc26e94-cf02-45f1-a54c-6818998f17bc.jpg?v=1775654726"
      },
      {
        "id": 44831033458874,
        "name": "22",
        "hex": "#EFA672",
        "price": 38,
        "available": true,
        "sku": "M021-US-2200",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-22_6d2670ca-92fb-4be7-bc82-7bcb7f95f769.jpg?v=1755210270"
      },
      {
        "id": 44831033491642,
        "name": "24",
        "hex": "#DFB186",
        "price": 38,
        "available": true,
        "sku": "M021-US-2400",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-24_c6f1babd-7e70-4cfb-af0e-aaf426828c19.jpg?v=1747424397"
      },
      {
        "id": 45762207842490,
        "name": "25",
        "hex": "#EFBC8F",
        "price": 38,
        "available": true,
        "sku": "M021-US-2500",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-TheUniform-Soldier-US-25_d7d165c4-6b27-4c7d-b1d0-8ca6dcd2f356.jpg?v=1775654747"
      },
      {
        "id": 44831033524410,
        "name": "26",
        "hex": "#E0B296",
        "price": 38,
        "available": true,
        "sku": "M021-US-2600",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-26_7e8e71a2-4805-40f9-a67b-1e6bbee07178.jpg?v=1752688773"
      },
      {
        "id": 44831033557178,
        "name": "28",
        "hex": "#EAC69F",
        "price": 38,
        "available": true,
        "sku": "M021-US-2800",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-28_7eb7dff9-75a5-4706-a6e0-33c49a4a547f.jpg?v=1753822234"
      },
      {
        "id": 44831033589946,
        "name": "30",
        "hex": "#E6C3B4",
        "price": 38,
        "available": true,
        "sku": "M021-US-3000",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT-TheUniform-Soldier-US-30_b82addcd-45ea-4b7f-9f26-c67692cb831f.jpg?v=1753453018"
      },
      {
        "id": 45762207875258,
        "name": "31",
        "hex": "#EFCBB3",
        "price": 38,
        "available": true,
        "sku": "M021-US-3100",
        "featured_image": "https://cdn.shopify.com/s/files/1/0412/1296/9117/files/MERIT26-TheUniform-Soldier-US-31_e11f28e7-e35f-4c1d-af31-833acaf143f1.jpg?v=1775654763"
      }
    ]
  },
  "the-intro-set": {
    "handle": "the-intro-set",
    "title": "The Intro Set",
    "subtitle": "Top-Rated Essentials",
    "category": "Sets & Bundles",
    "price": 119,
    "retail_value": 132,
    "savings": 13,
    "savings_percentage": "10%",
    "value_badge": "Set Price $119 (Retail Value $132 — Save $13)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Free shipping included",
      "Free shade exchanges within 30 days",
      "10% bundle savings vs individual items"
    ],
    "included_items": [
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Bronze Balm",
        "tag": "Sheer Bronzer",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Sheer, buildable cream formula that’s impossible to mess up. Creates natural warmth and soft definition."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist",
        "handle": "the-minimalist",
        "options": []
      },
      {
        "step": 3,
        "title": "Bronze Balm",
        "handle": "bronze-balm",
        "options": []
      },
      {
        "step": 4,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "Can I choose my own shades in The Intro Set?",
        "a": "Yes! Each product in The Intro Set is individually shade-matched to your preference during customization."
      },
      {
        "q": "What if a shade in my set is not a perfect match?",
        "a": "We offer complimentary, free shade exchanges on any set item within 30 days."
      },
      {
        "q": "Does this set come with The Signature Bag?",
        "a": "Yes, The Signature Bag is included automatically with your order at no extra charge."
      },
      {
        "q": "Is Brush No. 1 cruelty-free?",
        "a": "Yes, Brush No. 1 is crafted with dense, ultra-soft vegan bristles engineered for sensitive skin."
      }
    ]
  },
  "the-great-skin-duo": {
    "handle": "the-great-skin-duo",
    "title": "The Great Skin Duo",
    "subtitle": "Skincare Essentials",
    "category": "Sets & Bundles",
    "price": 76,
    "retail_value": 84,
    "savings": 8,
    "savings_percentage": "10%",
    "value_badge": "Set Price $76 (Retail Value $84 — Save $8)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Free shipping included",
      "National Eczema Association Seal of Acceptance on both products",
      "10% bundle savings vs individual items"
    ],
    "included_items": [
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Great Skin Priming Moisturizer",
        "tag": "Priming Moisturizer",
        "what_is": "Weightless priming moisturizer that absorbs seamlessly into the skin, providing 8-hour deep hydration and a cashmere-like canvas.",
        "what_does": "Features our proprietary Great Skin™ Complex with low-molecular peptides, spermidine, and polysaccharides to reinforce elasticity and lock in moisture."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Instant Glow Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 2,
        "title": "Great Skin Priming Moisturizer",
        "handle": "great-skin-moisturizer",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How do I use The Great Skin Duo together?",
        "a": "Apply 2-3 pumps of Great Skin Serum after cleansing, followed immediately by 1-2 pumps of Priming Moisturizer to lock in 24-hour hydration and prep skin for seamless makeup application."
      },
      {
        "q": "Is this duo suitable for sensitive or acne-prone skin?",
        "a": "Yes, both products are non-comedogenic, dermatologist-tested, fragrance-free, and bear the National Eczema Association Seal of Acceptance."
      },
      {
        "q": "Will this duo make my makeup pill?",
        "a": "No. Both formulas are completely oil-free and engineered with biomimetic emulsifiers that grip onto makeup without pilling or leaving residue."
      }
    ]
  },
  "the-great-skin-trio": {
    "handle": "the-great-skin-trio",
    "title": "The Great Skin Trio",
    "subtitle": "Complete Skincare Routine",
    "category": "Sets & Bundles",
    "price": 99,
    "retail_value": 116,
    "savings": 17,
    "savings_percentage": "15%",
    "value_badge": "Set Price $99 (Retail Value $116 — Save $17)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Complete 3-step cleanse, treat, and hydrate regimen",
      "Free shipping included",
      "15% bundle savings"
    ],
    "included_items": [
      {
        "title": "Great Skin Double Cleanse",
        "tag": "2-in-1 Makeup Remover & Cleanser",
        "what_is": "A two-in-one makeup remover and cleanser that thoroughly removes sunscreen and face makeup while preserving the skin barrier.",
        "what_does": "A 2-in-1 oil-free bi-phase wash that emulsifies makeup and debris without stripping sensitive skin. Oat-derived amino acids soothe and calm."
      },
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Great Skin Priming Moisturizer",
        "tag": "Priming Moisturizer",
        "what_is": "Weightless priming moisturizer that absorbs seamlessly into the skin, providing 8-hour deep hydration and a cashmere-like canvas.",
        "what_does": "Features our proprietary Great Skin™ Complex with low-molecular peptides, spermidine, and polysaccharides to reinforce elasticity and lock in moisture."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Double Cleanse",
        "handle": "great-skin-double-cleanse",
        "options": []
      },
      {
        "step": 2,
        "title": "Great Skin Instant Glow Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 3,
        "title": "Great Skin Priming Moisturizer",
        "handle": "great-skin-moisturizer",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is the recommended routine order for The Great Skin Trio?",
        "a": "Step 1: Wash with Great Skin Double Cleanse on damp skin (or massage dry skin first to melt stubborn makeup). Step 2: Shake Great Skin Serum and press 2-3 pumps into face and neck. Step 3: Seal with 1-2 pumps of Great Skin Moisturizer."
      },
      {
        "q": "Can I use this routine both morning and night?",
        "a": "Yes, all three products are designed for twice-daily use to balance, plump, and protect your skin barrier."
      }
    ]
  },
  "five-minute-morning": {
    "handle": "five-minute-morning",
    "title": "Five Minute Morning",
    "subtitle": "The Core Collection",
    "category": "Sets & Bundles",
    "price": 177,
    "retail_value": 208,
    "savings": 31,
    "savings_percentage": "15%",
    "value_badge": "Set Price $177 (Retail Value $208 — Save $31)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Free shipping included",
      "Covers entire everyday look in 7 curated steps",
      "Complimentary shade exchanges within 30 days"
    ],
    "included_items": [
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Day Glow",
        "tag": "Highlighting Balm",
        "what_is": "A translucent, moisturizing highlighter that illuminates skin for that fresh-morning-dewdrop-on-a-flushed-cheek look.",
        "what_does": "The vitamin-rich base replenishes moisture for a dewy glow that lasts beyond makeup. Plant-based squalane locks in hydration with zero glitter."
      },
      {
        "title": "Shade Slick",
        "tag": "Tinted Lip Oil",
        "what_is": "Somewhere between an oil and a light stain, this lip tint was made for whenever and wherever.",
        "what_does": "Infused with rosehip oil rich in omega-3 fatty acids known to support a healthy skin barrier function. Delivers high shine without stickiness."
      },
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "Brow 1980",
        "tag": "Volumizing Pomade",
        "what_is": "This tinted flexible pomade shapes and grooms your brows into place for natural, bold arches.",
        "what_does": "Kaolin clay and mineral pigments build natural-looking color. Tapered precision brush makes it easy to control application and hold brows all day."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "The Minimalist",
        "handle": "the-minimalist",
        "options": []
      },
      {
        "step": 2,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      },
      {
        "step": 3,
        "title": "Day Glow",
        "handle": "day-glow",
        "options": []
      },
      {
        "step": 4,
        "title": "Lip Choice",
        "handle": "lips",
        "options": []
      },
      {
        "step": 5,
        "title": "Mascara Choice",
        "handle": "lashes",
        "options": []
      },
      {
        "step": 6,
        "title": "Brow 1980",
        "handle": "brow-1980",
        "options": []
      },
      {
        "step": 7,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is included in the Five Minute Morning?",
        "a": "The Five Minute Morning includes 7 essentials: The Minimalist, Brush No. 1, Flush Balm, Day Glow, your choice of Lip (Shade Slick or Signature Lip), your choice of Mascara (Clean Lash or Clean Volume), and Brow 1980, plus The Signature Bag."
      },
      {
        "q": "How much do I save with Five Minute Morning?",
        "a": "You save $31 off the combined individual retail value of $208."
      }
    ]
  },
  "the-eye-set": {
    "handle": "the-eye-set",
    "title": "The Eye Set",
    "subtitle": "Eye & Brow",
    "category": "Sets & Bundles",
    "price": 110,
    "retail_value": 122,
    "savings": 12,
    "savings_percentage": "10%",
    "value_badge": "Set Price $110 (Retail Value $122 — Save $12)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Free shipping included",
      "Complete eye look: shadow, dual brush, liner/brow pencil, pomade, and mascara"
    ],
    "included_items": [
      {
        "title": "Solo Shadow",
        "tag": "Cream-to-Powder Eyeshadow",
        "what_is": "A buildable, talc-free, cream-to-powder single eyeshadow that is easy to use and gives a soft-matte wash of color.",
        "what_does": "Chamomile and calendula extracts soothe the delicate eye area; magnolia bark extract helps smooth appearance while staying crease-free for 8+ hours."
      },
      {
        "title": "Brush No. 2",
        "tag": "Dual-Ended Eyeshadow Brush",
        "what_is": "A soft, dual-ended eyeshadow brush that can be used to create a wash of color and precise lines.",
        "what_does": "Densely packed bristles deposit just the right amount of product for easy, buildable coverage. Fluffy blending end and precision flat end."
      },
      {
        "title": "Brow 1980",
        "tag": "Volumizing Pomade",
        "what_is": "This tinted flexible pomade shapes and grooms your brows into place for natural, bold arches.",
        "what_does": "Kaolin clay and mineral pigments build natural-looking color. Tapered precision brush makes it easy to control application and hold brows all day."
      },
      {
        "title": "Brow 1990",
        "tag": "Sheer Gel Pencil",
        "what_is": "A microfine gel pencil that fills and defines brows for soft, natural-looking fullness.",
        "what_does": "Ultra-fine pencil creates soft strokes to add natural-looking fullness and definition. Soft gel formula glides on without snagging."
      },
      {
        "title": "Clean Volume",
        "tag": "Volumizing Tubing Mascara",
        "what_is": "A volume tubing mascara designed to add buildable fullness, lift, and separation.",
        "what_does": "Creates customizable volume that wears for up to 16 hours without smudging or flaking. Petite precision brush grabs every lash."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Solo Shadow",
        "handle": "solo-shadow",
        "options": []
      },
      {
        "step": 2,
        "title": "Brow 1980",
        "handle": "brow-1980",
        "options": []
      },
      {
        "step": 3,
        "title": "Brow 1990",
        "handle": "brow-1990",
        "options": []
      },
      {
        "step": 4,
        "title": "Brush No. 2",
        "handle": "brush-no-2",
        "options": []
      },
      {
        "step": 5,
        "title": "Clean Volume",
        "handle": "clean-volume",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What brush is included in The Eye Set?",
        "a": "The set includes Brush No. 2, a custom dual-ended vegan brush designed specifically to apply, buff, and line Solo Shadow."
      },
      {
        "q": "Is Solo Shadow crease-resistant on oily lids?",
        "a": "Yes, Solo Shadow sets to a soft powder finish that wears for 8+ hours without creasing or smudging."
      }
    ]
  },
  "the-complexion-set": {
    "handle": "the-complexion-set",
    "title": "The Complexion Set",
    "subtitle": "Skin Color",
    "category": "Sets & Bundles",
    "price": 185,
    "retail_value": 206,
    "savings": 21,
    "savings_percentage": "10%",
    "value_badge": "Set Price $185 (Retail Value $206 — Save $21)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Preps, evens, warms, and illuminates in 6 coordinated steps",
      "Free shipping included"
    ],
    "included_items": [
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "Bronze Balm",
        "tag": "Sheer Bronzer",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Sheer, buildable cream formula that’s impossible to mess up. Creates natural warmth and soft definition."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Day Glow",
        "tag": "Highlighting Balm",
        "what_is": "A translucent, moisturizing highlighter that illuminates skin for that fresh-morning-dewdrop-on-a-flushed-cheek look.",
        "what_does": "The vitamin-rich base replenishes moisture for a dewy glow that lasts beyond makeup. Plant-based squalane locks in hydration with zero glitter."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist",
        "handle": "the-minimalist",
        "options": []
      },
      {
        "step": 3,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      },
      {
        "step": 4,
        "title": "Bronze Balm",
        "handle": "bronze-balm",
        "options": []
      },
      {
        "step": 5,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      },
      {
        "step": 6,
        "title": "Day Glow",
        "handle": "day-glow",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How do the products in The Complexion Set work together?",
        "a": "Start by hydrating with Great Skin Serum. Follow with The Minimalist buffed out with Brush No. 1. Then add warmth with Bronze Balm, color with Flush Balm, and high points with Day Glow."
      }
    ]
  },
  "the-cheek-set": {
    "handle": "the-cheek-set",
    "title": "The Cheek Set",
    "subtitle": "Glow & Flush Routine",
    "category": "Sets & Bundles",
    "price": 107,
    "retail_value": 126,
    "savings": 19,
    "savings_percentage": "15%",
    "value_badge": "Set Price $107 (Retail Value $126 — Save $19)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Includes Bronze Balm, Flush Balm, Day Glow, and Brush No. 1",
      "15% bundle savings"
    ],
    "included_items": [
      {
        "title": "Bronze Balm",
        "tag": "Sheer Bronzer",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Sheer, buildable cream formula that’s impossible to mess up. Creates natural warmth and soft definition."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Day Glow",
        "tag": "Highlighting Balm",
        "what_is": "A translucent, moisturizing highlighter that illuminates skin for that fresh-morning-dewdrop-on-a-flushed-cheek look.",
        "what_does": "The vitamin-rich base replenishes moisture for a dewy glow that lasts beyond makeup. Plant-based squalane locks in hydration with zero glitter."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Bronze Balm",
        "handle": "bronze-balm",
        "options": []
      },
      {
        "step": 2,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      },
      {
        "step": 3,
        "title": "Day Glow",
        "handle": "day-glow",
        "options": []
      },
      {
        "step": 4,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "Can I blend Flush Balm and Bronze Balm with Brush No. 1?",
        "a": "Yes! Brush No. 1 is designed to diffuse cream balms into the skin seamlessly without disturbing underlying makeup."
      }
    ]
  },
  "the-bestsellers-set": {
    "handle": "the-bestsellers-set",
    "title": "The Bestsellers Set",
    "subtitle": "Most-Loved Favorites",
    "category": "Sets & Bundles",
    "price": 134,
    "retail_value": 149,
    "savings": 15,
    "savings_percentage": "10%",
    "value_badge": "Set Price $134 (Retail Value $149 — Save $15)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Features full sizes of The Minimalist and Flush Balm, plus travel sizes of Great Skin Serum, Retrospect, and Mascara",
      "Free shipping included"
    ],
    "included_items": [
      {
        "title": "Great Skin Serum (15ml Travel Size)",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "Retrospect (9.5ml Travel Size)",
        "tag": "L’Extrait de Parfum",
        "what_is": "A rich, nuanced extrait de parfum with nearly 30% fragrance concentration that sits close to the skin and evolves over 12+ hours.",
        "what_does": "Opens with crisp bergamot, ambrette, and aldehydes, transitions through a heart of jasmine, rose, and orris, and settles into warm vanilla, musk, and moss."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 2,
        "title": "Clean Lash or Clean Volume",
        "handle": "lashes",
        "options": []
      },
      {
        "step": 3,
        "title": "Retrospect L’Extrait de Parfum",
        "handle": "retrospect",
        "options": []
      },
      {
        "step": 4,
        "title": "The Minimalist Complexion Stick",
        "handle": "complexion",
        "options": []
      },
      {
        "step": 5,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What sizes are included in The Bestsellers Set?",
        "a": "The set includes full-size The Minimalist and Flush Balm, alongside deluxe travel sizes of Great Skin Serum (15ml), Retrospect L’Extrait de Parfum (9.5ml), and your choice of mascara."
      }
    ]
  },
  "the-icons-set": {
    "handle": "the-icons-set",
    "title": "The Icons Set",
    "subtitle": "Signature Hero Products",
    "category": "Sets & Bundles",
    "price": 131,
    "retail_value": 146,
    "savings": 15,
    "savings_percentage": "10%",
    "value_badge": "Set Price $131 (Retail Value $146 — Save $15)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Four iconic hero products for complexion, skin, and scent",
      "Free shipping included"
    ],
    "included_items": [
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Retrospect (9.5ml Travel Size)",
        "tag": "L’Extrait de Parfum",
        "what_is": "A rich, nuanced extrait de parfum with nearly 30% fragrance concentration that sits close to the skin and evolves over 12+ hours.",
        "what_does": "Opens with crisp bergamot, ambrette, and aldehydes, transitions through a heart of jasmine, rose, and orris, and settles into warm vanilla, musk, and moss."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist",
        "handle": "complexion",
        "options": []
      },
      {
        "step": 3,
        "title": "Great Skin Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 4,
        "title": "Retrospect",
        "handle": "retrospect",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is The Icons Set designed for?",
        "a": "It combines the foundational products that established MERIT: effortless skin prep, targeted complexion perfection, blending precision, and our signature fine fragrance."
      }
    ]
  },
  "brow-duo": {
    "handle": "brow-duo",
    "title": "The Brow Duo",
    "subtitle": "Brow Essentials",
    "category": "Sets & Bundles",
    "price": 44,
    "retail_value": 48,
    "savings": 4,
    "savings_percentage": "8%",
    "value_badge": "Set Price $44 (Retail Value $48 — Save $4)",
    "key_perks": [
      "The Signature Bag included with qualifying first order",
      "Complete arch definition & all-day hold duo",
      "Complementary free shade exchanges"
    ],
    "included_items": [
      {
        "title": "Brow 1980",
        "tag": "Volumizing Pomade",
        "what_is": "This tinted flexible pomade shapes and grooms your brows into place for natural, bold arches.",
        "what_does": "Kaolin clay and mineral pigments build natural-looking color. Tapered precision brush makes it easy to control application and hold brows all day."
      },
      {
        "title": "Brow 1990",
        "tag": "Sheer Gel Pencil",
        "what_is": "A microfine gel pencil that fills and defines brows for soft, natural-looking fullness.",
        "what_does": "Ultra-fine pencil creates soft strokes to add natural-looking fullness and definition. Soft gel formula glides on without snagging."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Brow 1980",
        "handle": "brow-1980",
        "options": []
      },
      {
        "step": 2,
        "title": "Brow 1990",
        "handle": "brow-1990",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How do I use Brow 1980 and Brow 1990 together?",
        "a": "Use Brow 1990 microfine pencil to shape arches and sketch realistic hair-like strokes. Follow with Brow 1980 pomade to add flexible volume and lock hairs in place."
      }
    ]
  },
  "the-base-set": {
    "handle": "the-base-set",
    "title": "The Base Set",
    "subtitle": "Skin Prep & Complexion",
    "category": "Sets & Bundles",
    "price": 101,
    "retail_value": 112,
    "savings": 11,
    "savings_percentage": "10%",
    "value_badge": "Set Price $101 (Retail Value $112 — Save $11)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Hydrate, perfect, and blend in 3 essential steps",
      "Free shipping included"
    ],
    "included_items": [
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist",
        "handle": "the-minimalist",
        "options": []
      },
      {
        "step": 3,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "Why pair Great Skin Serum with The Minimalist?",
        "a": "Great Skin Serum nearly doubles skin hydration in five minutes and provides the perfect glide for The Minimalist stick, preventing patchiness."
      }
    ]
  },
  "the-everyday-set": {
    "handle": "the-everyday-set",
    "title": "The Everyday Set",
    "subtitle": "Daily Minimalist Edit",
    "category": "Sets & Bundles",
    "price": 118,
    "retail_value": 128,
    "savings": 10,
    "savings_percentage": "8%",
    "value_badge": "Set Price $118 (Retail Value $128 — Save $10)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Includes Mascara, Complexion Stick, Bronzer, and Blush",
      "Free shipping included"
    ],
    "included_items": [
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Bronze Balm",
        "tag": "Sheer Bronzer",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Sheer, buildable cream formula that’s impossible to mess up. Creates natural warmth and soft definition."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Clean Lash or Clean Volume",
        "handle": "lashes",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist",
        "handle": "complexion",
        "options": []
      },
      {
        "step": 3,
        "title": "Bronze Balm",
        "handle": "bronze-balm",
        "options": []
      },
      {
        "step": 4,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What does The Everyday Set contain?",
        "a": "The essential quartet for an effortless daily face: define eyes with Clean Lash, even skin with The Minimalist, warm up with Bronze Balm, and add a pop of healthy cheek color with Flush Balm."
      }
    ]
  },
  "the-color-duo": {
    "handle": "the-color-duo",
    "title": "The Color Duo",
    "subtitle": "Monochromatic Lip & Cheek",
    "category": "Sets & Bundles",
    "price": 48,
    "retail_value": 54,
    "savings": 6,
    "savings_percentage": "11%",
    "value_badge": "Set Price $48 (Retail Value $54 — Save $6)",
    "key_perks": [
      "Coordinating Flush Balm and Signature Lip Liner pairing",
      "7 pre-curated shade combinations",
      "11% savings vs purchasing separately"
    ],
    "included_items": [
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Signature Lip Liner",
        "tag": "Hydrating Lip Liner",
        "what_is": "A hydrating, buildable lip pencil for creating soft definition and sheer all-over color.",
        "what_does": "Smooth, lightweight gel formula glides on easily without crumbling or skipping. Use it to contour lips or fill in completely for all-day wear."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Curated Palette Selection",
        "handle": "color-palette",
        "options": [
          "The Cool Plums",
          "The Brown Pinks",
          "The Soft Pinks",
          "The Bright Pinks",
          "The Rose Browns",
          "The Cool Berries",
          "The Warm Browns"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What products are in The Color Duo?",
        "a": "The Color Duo pairs our Signature Lip Liner with coordinating Flush Balm cheek color for a cohesive, monochromatic aesthetic."
      }
    ]
  },
  "the-color-trio": {
    "handle": "the-color-trio",
    "title": "The Color Trio",
    "subtitle": "Complete Monochromatic Look",
    "category": "Sets & Bundles",
    "price": 70,
    "retail_value": 78,
    "savings": 8,
    "savings_percentage": "10%",
    "value_badge": "Set Price $70 (Retail Value $78 — Save $8)",
    "key_perks": [
      "Tri-product harmony: Signature Lip Liner, Flush Balm, and Lip Oil/Lipstick",
      "7 curated color families",
      "10% savings"
    ],
    "included_items": [
      {
        "title": "Signature Lip Liner",
        "tag": "Hydrating Lip Liner",
        "what_is": "A hydrating, buildable lip pencil for creating soft definition and sheer all-over color.",
        "what_does": "Smooth, lightweight gel formula glides on easily without crumbling or skipping. Use it to contour lips or fill in completely for all-day wear."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Signature Lip",
        "tag": "Hydrating Lipstick",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Color Palette Selection",
        "handle": "color-trio-palette",
        "options": [
          "The Cool Plums",
          "The Brown Pinks",
          "The Soft Pinks",
          "The Bright Pinks",
          "The Rose Browns",
          "The Cool Berries",
          "The Warm Browns"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What is The Color Trio?",
        "a": "It is a 3-piece curated monochromatic collection combining Signature Lip Liner, Flush Balm cheek color, and a coordinating lip color (Shade Slick or Signature Lip)."
      }
    ]
  },
  "the-mascara-duo": {
    "handle": "the-mascara-duo",
    "title": "The Mascara Duo",
    "subtitle": "Length & Volume Pair",
    "category": "Sets & Bundles",
    "price": 50,
    "retail_value": 56,
    "savings": 6,
    "savings_percentage": "11%",
    "value_badge": "Set Price $50 (Retail Value $56 — Save $6)",
    "key_perks": [
      "Features both Clean Lash (length) and Clean Volume (fullness)",
      "11% savings vs separate purchase",
      "Smudge-free tubing wear that rinses off with warm water"
    ],
    "included_items": [
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "Clean Volume",
        "tag": "Volumizing Tubing Mascara",
        "what_is": "A volume tubing mascara designed to add buildable fullness, lift, and separation.",
        "what_does": "Creates customizable volume that wears for up to 16 hours without smudging or flaking. Petite precision brush grabs every lash."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Clean Lash",
        "handle": "clean-lash",
        "options": []
      },
      {
        "step": 2,
        "title": "Clean Volume",
        "handle": "clean-volume",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "Can I layer Clean Lash and Clean Volume?",
        "a": "Yes! For dramatic eyes, apply Clean Volume at the base to build dense thickness, then swipe Clean Lash through tips to elongate and fan lashes out."
      }
    ]
  },
  "the-clean-lash-duo": {
    "handle": "the-clean-lash-duo",
    "title": "The Clean Lash Duo",
    "subtitle": "Twin Lengthening Tubing Mascaras",
    "category": "Sets & Bundles",
    "price": 50,
    "retail_value": 56,
    "savings": 6,
    "savings_percentage": "11%",
    "value_badge": "Set Price $50 (Retail Value $56 — Save $6)",
    "key_perks": [
      "Two full-size Clean Lash tubing mascaras",
      "Choose Perfect Black and/or Warm Brown",
      "11% savings"
    ],
    "included_items": [
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "Clean Lash (Second Tube)",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Clean Lash #1",
        "handle": "clean-lash-1",
        "options": []
      },
      {
        "step": 2,
        "title": "Clean Lash #2",
        "handle": "clean-lash-2",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How do I remove Clean Lash?",
        "a": "Clean Lash requires no harsh rubbing or makeup remover; simply apply warm water and gentle fingertip pressure, and the polymer tubes slide effortlessly off."
      }
    ]
  },
  "the-clean-volume-duo": {
    "handle": "the-clean-volume-duo",
    "title": "The Clean Volume Duo",
    "subtitle": "Twin Volumizing Tubing Mascaras",
    "category": "Sets & Bundles",
    "price": 50,
    "retail_value": 56,
    "savings": 6,
    "savings_percentage": "11%",
    "value_badge": "Set Price $50 (Retail Value $56 — Save $6)",
    "key_perks": [
      "Two full-size Clean Volume mascaras",
      "16-hour smudge-resistant fullness",
      "11% savings"
    ],
    "included_items": [
      {
        "title": "Clean Volume",
        "tag": "Volumizing Tubing Mascara",
        "what_is": "A volume tubing mascara designed to add buildable fullness, lift, and separation.",
        "what_does": "Creates customizable volume that wears for up to 16 hours without smudging or flaking. Petite precision brush grabs every lash."
      },
      {
        "title": "Clean Volume (Second Tube)",
        "tag": "Volumizing Tubing Mascara",
        "what_is": "A volume tubing mascara designed to add buildable fullness, lift, and separation.",
        "what_does": "Creates customizable volume that wears for up to 16 hours without smudging or flaking. Petite precision brush grabs every lash."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Clean Volume #1",
        "handle": "clean-volume-1",
        "options": []
      },
      {
        "step": 2,
        "title": "Clean Volume #2",
        "handle": "clean-volume-2",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How is Clean Volume different from Clean Lash?",
        "a": "Clean Lash focuses on clean length and fluttery separation, while Clean Volume features a curved precision wand and volumizing fiber formula to deliver thick, plush body."
      }
    ]
  },
  "the-full-collection": {
    "handle": "the-full-collection",
    "title": "The Full Collection",
    "subtitle": "Every MERIT Product",
    "category": "Sets & Bundles",
    "price": 440,
    "retail_value": 516,
    "savings": 76,
    "savings_percentage": "15%",
    "value_badge": "Set Price $440 (Retail Value $516 — Save $76)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "The complete 17-formula MERIT cosmetic wardrobe",
      "Maximum savings of $76 across full suite",
      "Free express shipping included"
    ],
    "included_items": [
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Great Skin Priming Moisturizer",
        "tag": "Priming Moisturizer",
        "what_is": "Weightless priming moisturizer that absorbs seamlessly into the skin, providing 8-hour deep hydration and a cashmere-like canvas.",
        "what_does": "Features our proprietary Great Skin™ Complex with low-molecular peptides, spermidine, and polysaccharides to reinforce elasticity and lock in moisture."
      },
      {
        "title": "Great Skin Double Cleanse",
        "tag": "2-in-1 Makeup Remover & Cleanser",
        "what_is": "A two-in-one makeup remover and cleanser that thoroughly removes sunscreen and face makeup while preserving the skin barrier.",
        "what_does": "A 2-in-1 oil-free bi-phase wash that emulsifies makeup and debris without stripping sensitive skin. Oat-derived amino acids soothe and calm."
      },
      {
        "title": "The Minimalist",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "Brush No. 2",
        "tag": "Dual-Ended Eyeshadow Brush",
        "what_is": "A soft, dual-ended eyeshadow brush that can be used to create a wash of color and precise lines.",
        "what_does": "Densely packed bristles deposit just the right amount of product for easy, buildable coverage. Fluffy blending end and precision flat end."
      },
      {
        "title": "Bronze Balm",
        "tag": "Sheer Bronzer",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Sheer, buildable cream formula that’s impossible to mess up. Creates natural warmth and soft definition."
      },
      {
        "title": "Flush Balm",
        "tag": "Cheek Color",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Day Glow",
        "tag": "Highlighting Balm",
        "what_is": "A translucent, moisturizing highlighter that illuminates skin for that fresh-morning-dewdrop-on-a-flushed-cheek look.",
        "what_does": "The vitamin-rich base replenishes moisture for a dewy glow that lasts beyond makeup. Plant-based squalane locks in hydration with zero glitter."
      },
      {
        "title": "Clean Lash",
        "tag": "Tubing Mascara",
        "what_is": "An everyday tubing mascara that defines, separates and lengthens lashes for a wide-awake look.",
        "what_does": "Proprietary tubing technology wraps and defines each lash. Fatty acids and olive oil esters condition and nourish lashes while easily rinsing off with warm water."
      },
      {
        "title": "Brow 1980",
        "tag": "Volumizing Pomade",
        "what_is": "This tinted flexible pomade shapes and grooms your brows into place for natural, bold arches.",
        "what_does": "Kaolin clay and mineral pigments build natural-looking color. Tapered precision brush makes it easy to control application and hold brows all day."
      },
      {
        "title": "Brow 1990",
        "tag": "Sheer Gel Pencil",
        "what_is": "A microfine gel pencil that fills and defines brows for soft, natural-looking fullness.",
        "what_does": "Ultra-fine pencil creates soft strokes to add natural-looking fullness and definition. Soft gel formula glides on without snagging."
      },
      {
        "title": "Solo Shadow",
        "tag": "Cream-to-Powder Eyeshadow",
        "what_is": "A buildable, talc-free, cream-to-powder single eyeshadow that is easy to use and gives a soft-matte wash of color.",
        "what_does": "Chamomile and calendula extracts soothe the delicate eye area; magnolia bark extract helps smooth appearance while staying crease-free for 8+ hours."
      },
      {
        "title": "Signature Lip",
        "tag": "Hydrating Lipstick",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      },
      {
        "title": "Signature Lip Liner",
        "tag": "Hydrating Lip Liner",
        "what_is": "A hydrating, buildable lip pencil for creating soft definition and sheer all-over color.",
        "what_does": "Smooth, lightweight gel formula glides on easily without crumbling or skipping. Use it to contour lips or fill in completely for all-day wear."
      },
      {
        "title": "Shade Slick",
        "tag": "Tinted Lip Oil",
        "what_is": "Somewhere between an oil and a light stain, this lip tint was made for whenever and wherever.",
        "what_does": "Infused with rosehip oil rich in omega-3 fatty acids known to support a healthy skin barrier function. Delivers high shine without stickiness."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Great Skin Serum",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 2,
        "title": "Great Skin Moisturizer",
        "handle": "great-skin-moisturizer",
        "options": []
      },
      {
        "step": 3,
        "title": "Great Skin Double Cleanse",
        "handle": "great-skin-double-cleanse",
        "options": []
      },
      {
        "step": 4,
        "title": "The Minimalist",
        "handle": "the-minimalist",
        "options": []
      },
      {
        "step": 5,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      },
      {
        "step": 6,
        "title": "Brush No. 2",
        "handle": "brush-no-2",
        "options": []
      },
      {
        "step": 7,
        "title": "Flush Balm",
        "handle": "flush-balm",
        "options": []
      },
      {
        "step": 8,
        "title": "Bronze Balm",
        "handle": "bronze-balm",
        "options": []
      },
      {
        "step": 9,
        "title": "Day Glow",
        "handle": "day-glow",
        "options": []
      },
      {
        "step": 10,
        "title": "Clean Lash",
        "handle": "clean-lash",
        "options": []
      },
      {
        "step": 11,
        "title": "Brow 1980",
        "handle": "brow-1980",
        "options": []
      },
      {
        "step": 12,
        "title": "Brow 1990",
        "handle": "brow-1990",
        "options": []
      },
      {
        "step": 13,
        "title": "Solo Shadow",
        "handle": "solo-shadow",
        "options": []
      },
      {
        "step": 14,
        "title": "Signature Lip",
        "handle": "signature-lip",
        "options": []
      },
      {
        "step": 15,
        "title": "Signature Lip Liner",
        "handle": "signature-lip-liner",
        "options": []
      },
      {
        "step": 16,
        "title": "Shade Slick",
        "handle": "shade-slick",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is included in The Full Collection?",
        "a": "The Full Collection includes all 17 iconic MERIT formulas across skincare, complexion, cheeks, eyes, and lips, plus The Signature Bag."
      },
      {
        "q": "What is the savings on The Full Collection?",
        "a": "You save $76 off individual retail prices."
      }
    ]
  },
  "the-edit-set": {
    "handle": "the-edit-set",
    "title": "The Edit Set",
    "subtitle": "Conceal & Sculpt Complexion Set",
    "category": "Sets & Bundles",
    "price": 96,
    "retail_value": 108,
    "savings": 12,
    "savings_percentage": "11%",
    "value_badge": "Set Price $96 (Retail Value $108 — Save $12)",
    "key_perks": [
      "The Signature Bag included complimentary",
      "Two shades of The Minimalist (one conceal, one contour) + Brush No. 1",
      "11% savings vs separate purchase"
    ],
    "included_items": [
      {
        "title": "The Minimalist (Conceal Shade)",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "The Minimalist (Sculpt Shade)",
        "tag": "Complexion Stick",
        "what_is": "Get compliments on your skin, not your makeup. We designed this in place of all-over coverage, so you can conceal and perfect where you need it.",
        "what_does": "Lightweight, hydrating formula wears throughout the day without settling into fine lines. Buildable light-to-medium coverage."
      },
      {
        "title": "Brush No. 1",
        "tag": "Blending Brush",
        "what_is": "Brush No. 1 softly blends complexion products into your skin for a natural, airbrushed finish.",
        "what_does": "Densely packed bristles make blending easy. Extra soft, vegan bristles are gentle on reactive skin."
      },
      {
        "title": "The Signature Bag",
        "tag": "Complimentary Keepsake",
        "what_is": "MERIT’s iconic corduroy tie-top makeup bag, designed to hold your daily essentials in effortless style.",
        "what_does": "Machine-washable, ultra-soft travel pouch included automatically with curated sets and first purchases."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "The Minimalist (Conceal)",
        "handle": "the-minimalist-conceal",
        "options": []
      },
      {
        "step": 2,
        "title": "The Minimalist (Sculpt)",
        "handle": "the-minimalist-sculpt",
        "options": []
      },
      {
        "step": 3,
        "title": "Brush No. 1",
        "handle": "brush-no-1",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "How do I choose my sculpt shade for The Edit Set?",
        "a": "We recommend selecting a shade 2 to 3 levels deeper than your concealing shade with a cool or neutral undertone to mimic natural facial shadows."
      }
    ]
  },
  "the-mini-great-skin-trio": {
    "handle": "the-mini-great-skin-trio",
    "title": "The Mini Great Skin Trio",
    "subtitle": "Travel-Size Skincare Routine",
    "category": "Sets & Bundles",
    "price": 42,
    "retail_value": 54,
    "savings": 12,
    "savings_percentage": "22%",
    "value_badge": "Set Price $42 (Retail Value $54 — Save $12)",
    "key_perks": [
      "TSA-approved travel sizes of best-selling skincare",
      "Exclusive first look preview of Great Skin Rich Moisturizer",
      "22% savings"
    ],
    "included_items": [
      {
        "title": "Great Skin Double Cleanse (50ml Travel Size)",
        "tag": "2-in-1 Makeup Remover & Cleanser",
        "what_is": "A two-in-one makeup remover and cleanser that thoroughly removes sunscreen and face makeup while preserving the skin barrier.",
        "what_does": "A 2-in-1 oil-free bi-phase wash that emulsifies makeup and debris without stripping sensitive skin. Oat-derived amino acids soothe and calm."
      },
      {
        "title": "Great Skin Instant Glow Serum (15ml Travel Size)",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      },
      {
        "title": "Great Skin Rich Moisturizer (15ml Preview Size)",
        "tag": "Priming Moisturizer",
        "what_is": "Weightless priming moisturizer that absorbs seamlessly into the skin, providing 8-hour deep hydration and a cashmere-like canvas.",
        "what_does": "Features our proprietary Great Skin™ Complex with low-molecular peptides, spermidine, and polysaccharides to reinforce elasticity and lock in moisture."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Double Cleanse (50ml)",
        "handle": "great-skin-double-cleanse",
        "options": []
      },
      {
        "step": 2,
        "title": "Instant Glow Serum (15ml)",
        "handle": "great-skin-serum",
        "options": []
      },
      {
        "step": 3,
        "title": "Rich Moisturizer (15ml)",
        "handle": "great-skin-rich-moisturizer",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is included in The Mini Great Skin Trio?",
        "a": "The set includes travel sizes of our two bestsellers — Great Skin Double Cleanse and Great Skin Instant Glow Serum — plus, a first look at our new Great Skin Rich Moisturizer."
      }
    ]
  },
  "the-signature-lip-trio": {
    "handle": "the-signature-lip-trio",
    "title": "MERIT x ERDEM | The Signature Lip Trio",
    "subtitle": "Limited Edition Lip Wardrobe",
    "category": "Sets & Bundles",
    "price": 62,
    "retail_value": 84,
    "savings": 22,
    "savings_percentage": "26%",
    "value_badge": "Set Price $62 (Retail Value $84 — Save $22)",
    "key_perks": [
      "Exclusive collaboration with London fashion house ERDEM",
      "Includes three full-size Signature Lip lipsticks across satin, sheer, and matte finishes",
      "26% savings ($22 off retail)"
    ],
    "included_items": [
      {
        "title": "Signature Lip Satin",
        "tag": "Hydrating Lipstick",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      },
      {
        "title": "Signature Lip Matte",
        "tag": "Hydrating Lipstick",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      },
      {
        "title": "Signature Lip Sheer (Exclusive ERDEM Shade)",
        "tag": "Hydrating Lipstick",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "ERDEM Curated Lip Trio",
        "handle": "erdem-lip-trio",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is special about the MERIT x ERDEM collection?",
        "a": "Curated by designer Erdem Moralioglu, this limited-edition set explores three distinct lip finishes in romantic couture-inspired shades."
      }
    ]
  },
  "the-winter-2026-set": {
    "handle": "the-winter-2026-set",
    "title": "MERIT x ERDEM | The Winter 2026 Set",
    "subtitle": "Limited Edition Holiday Set",
    "category": "Sets & Bundles",
    "price": 68,
    "retail_value": 92,
    "savings": 24,
    "savings_percentage": "26%",
    "value_badge": "Set Price $68 (Retail Value $92 — Save $24)",
    "key_perks": [
      "Exclusive limited edition collaboration with fashion designer ERDEM",
      "Seasonal limited-edition packaging and exclusive seasonal shades",
      "26% savings ($24 off individual value)"
    ],
    "included_items": [
      {
        "title": "Flush Balm (ERDEM Holiday Edition)",
        "tag": "Cheek Color (Limited Edition Packaging)",
        "what_is": "A foolproof, flexible balm that deposits a creamy, transparent veil of color to let your skin show through.",
        "what_does": "Microfine pigment powders deposit a touch of color, without covering up natural skin texture. Light, creamy texture melts into skin and stays in place all day."
      },
      {
        "title": "Signature Lip (ERDEM Holiday Edition)",
        "tag": "Hydrating Lipstick (Limited Edition Shade)",
        "what_is": "Lipstick you can live in™ — Comfortable color that’s so lightweight, you’ll forget you’re wearing it.",
        "what_does": "Sheer satin or matte finish color without the heaviness of traditional lipstick. Plant-derived squalane and sunflower seed wax deliver long-lasting moisture."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "MERIT x ERDEM Winter Harmony",
        "handle": "erdem-winter-set",
        "options": []
      }
    ],
    "faqs": [
      {
        "q": "What is The Winter 2026 Set?",
        "a": "A limited edition set for a soft, glowy look inspired by ERDEM’s romantic aesthetic, featuring Flush Balm and Signature Lip in custom packaging and exclusive shades."
      },
      {
        "q": "Are the shades exclusive to this set?",
        "a": "Yes, the shades were created exclusively for the holiday season in partnership with ERDEM."
      }
    ]
  },
  "great-skin-serum": {
    "handle": "great-skin-serum",
    "title": "Great Skin Serum",
    "subtitle": "Instant Glow Serum",
    "category": "Skincare",
    "price": 19,
    "retail_value": 19,
    "savings": 0,
    "savings_percentage": "0%",
    "value_badge": "Set Price $19 (Retail Value $19 — Save $0)",
    "key_perks": [
      "National Eczema Association Seal of Acceptance",
      "Clinically measured to nearly double hydration in 5 minutes",
      "Fragrance-free, non-comedogenic, and 100% vegan"
    ],
    "included_items": [
      {
        "title": "Great Skin Instant Glow Serum",
        "tag": "Bi-Phase Glow Serum",
        "what_is": "Lightweight bi-phase formula absorbs quickly into the skin with zero residue, so makeup goes on smooth and wears better throughout the day.",
        "what_does": "Infuses skin with 2% niacinamide, multi-weight hyaluronic acid, and cacao seed extract to visibly brighten, plump, and calm redness."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Size Selection",
        "handle": "great-skin-serum",
        "options": [
          "Travel Size (15ml) - $19",
          "Full Size (50ml) - $38"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What does Great Skin Serum do?",
        "a": "This gentle, bi-phase serum is clinically proven to brighten skin, hydrate for 24 hours, even tone, and reduce the look of redness in four weeks."
      },
      {
        "q": "How do I use Great Skin Serum in my routine?",
        "a": "Shake well before dispensing to blend the water and oil phases. Gently press 2-3 pumps onto clean skin morning and night before moisturizer and makeup."
      },
      {
        "q": "Is Great Skin Serum oil-free?",
        "a": "Great Skin Serum is an oil-free, water-based bi-phase formula that absorbs instantly with zero greasy residue."
      },
      {
        "q": "Can I wear this serum under makeup?",
        "a": "Yes! It was specifically formulated to act as the ultimate makeup prep step, smoothing texture so foundation applies evenly without piling."
      }
    ]
  },
  "great-skin-moisturizer": {
    "handle": "great-skin-moisturizer",
    "title": "Great Skin Moisturizer",
    "subtitle": "Priming Moisturizer",
    "category": "Skincare",
    "price": 19,
    "retail_value": 19,
    "savings": 0,
    "savings_percentage": "0%",
    "value_badge": "Set Price $19 (Retail Value $19 — Save $0)",
    "key_perks": [
      "National Eczema Association Seal of Acceptance",
      "Proprietary Great Skin Complex with peptides & spermidine",
      "Provides 8-hour deep hydration and blurred cashmere finish"
    ],
    "included_items": [
      {
        "title": "Great Skin Priming Moisturizer",
        "tag": "Priming Moisturizer",
        "what_is": "Weightless priming moisturizer that absorbs seamlessly into the skin, providing 8-hour deep hydration and a cashmere-like canvas.",
        "what_does": "Features our proprietary Great Skin™ Complex with low-molecular peptides, spermidine, and polysaccharides to reinforce elasticity and lock in moisture."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Size Selection",
        "handle": "great-skin-moisturizer",
        "options": [
          "Travel Size (15ml) - $19",
          "Full Size (50ml) - $38"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What does Great Skin Moisturizer do?",
        "a": "It is a weightless priming moisturizer that provides deep 8-hour hydration, reinforces the skin barrier, improves elasticity, and leaves a blurred, cashmere-like finish designed specifically to prime skin for makeup."
      },
      {
        "q": "What makes the Great Skin Complex unique?",
        "a": "Our proprietary Great Skin Complex combines low-molecular-weight peptides to plump, spermidine to protect cellular vitality and strengthen the moisture barrier, and polysaccharides to enhance firmness and elasticity."
      },
      {
        "q": "How do I use it with Great Skin Serum?",
        "a": "After cleansing, shake and apply 2–3 pumps of Great Skin Serum to infuse hydration. Immediately follow with 1–2 pumps of Great Skin Moisturizer to seal in moisture and prime the skin surface."
      },
      {
        "q": "Will it pill under makeup or sunscreen?",
        "a": "No. The formula utilizes biomimetic emulsifiers engineered specifically to absorb cleanly without tacky residue, creating a smooth canvas that grips makeup without pilling."
      },
      {
        "q": "Is it safe for sensitive and eczema-prone skin?",
        "a": "Yes. Great Skin Moisturizer holds the National Eczema Association Seal of Acceptance, is fragrance-free, dermatologist-tested, and non-comedogenic."
      }
    ]
  },
  "great-skin-double-cleanse": {
    "handle": "great-skin-double-cleanse",
    "title": "Great Skin Double Cleanse",
    "subtitle": "Makeup removing cleanser",
    "category": "Skincare",
    "price": 16,
    "retail_value": 16,
    "savings": 0,
    "savings_percentage": "0%",
    "value_badge": "Set Price $16 (Retail Value $16 — Save $0)",
    "key_perks": [
      "Two cleansers in one single bottle",
      "Effortlessly dissolves waterproof makeup and mineral SPF",
      "Oat-derived amino acids keep skin barrier hydrated and calm"
    ],
    "included_items": [
      {
        "title": "Great Skin Double Cleanse",
        "tag": "2-in-1 Makeup Remover & Cleanser",
        "what_is": "A two-in-one makeup remover and cleanser that thoroughly removes sunscreen and face makeup while preserving the skin barrier.",
        "what_does": "A 2-in-1 oil-free bi-phase wash that emulsifies makeup and debris without stripping sensitive skin. Oat-derived amino acids soothe and calm."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Size Selection",
        "handle": "great-skin-double-cleanse",
        "options": [
          "Travel Size (50ml) - $16",
          "Full Size (150ml) - $34"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What does Great Skin Double Cleanse do?",
        "a": "It is a 2-in-1 bi-phase formula combining an oil-free makeup remover and a gentle water-based wash that completely cleanses skin in one step without stripping moisture."
      },
      {
        "q": "Why is it called Double Cleanse if it is one step?",
        "a": "Traditional double-cleansing requires two separate bottles (an oil cleanser followed by a foaming wash). Great Skin Double Cleanse emulsifies both phases in a single bottle, delivering the benefits of a double cleanse in one easy step."
      },
      {
        "q": "Can I use it on dry skin to remove heavy makeup?",
        "a": "Yes. You can apply it directly to dry skin to melt through stubborn face makeup and SPF, then add water to rinse, or apply directly to wet skin for a fresh morning cleanse."
      },
      {
        "q": "Does it strip or dry out sensitive skin?",
        "a": "No. 100% of study participants confirmed it does not dry out skin. Its oat-derived amino acid surfactants and plant humectants preserve the moisture barrier."
      }
    ]
  },
  "retrospect": {
    "handle": "retrospect",
    "title": "Retrospect",
    "subtitle": "L’Extrait de Parfum",
    "category": "Skincare & Fragrance",
    "price": 34,
    "retail_value": 34,
    "savings": 0,
    "savings_percentage": "0%",
    "value_badge": "Set Price $34 (Retail Value $34 — Save $0)",
    "key_perks": [
      "Nearly 30% concentration extrait de parfum formulated in Paris",
      "Wears for 12+ hours with clean second-skin evolution",
      "Custom ergonomic pebble bottle design"
    ],
    "included_items": [
      {
        "title": "Retrospect",
        "tag": "L’Extrait de Parfum",
        "what_is": "A rich, nuanced extrait de parfum with nearly 30% fragrance concentration that sits close to the skin and evolves over 12+ hours.",
        "what_does": "Opens with crisp bergamot, ambrette, and aldehydes, transitions through a heart of jasmine, rose, and orris, and settles into warm vanilla, musk, and moss."
      }
    ],
    "steps": [
      {
        "step": 1,
        "title": "Size Selection",
        "handle": "retrospect",
        "options": [
          "Travel Size (9.5ml) - $34",
          "Full Size (30ml) - $92",
          "Value Size (60ml) - $138"
        ]
      }
    ],
    "faqs": [
      {
        "q": "What does MERIT Retrospect smell like?",
        "a": "It opens soft and clean, moves into a subtle floral center, and settles into a warm, second-skin finish of musk, vanilla, and moss."
      },
      {
        "q": "How long does Retrospect last and how does it wear?",
        "a": "As a highly concentrated extrait de parfum (nearly 30% fragrance oil), it wears for over 12 hours and sits close to the skin."
      },
      {
        "q": "What are the fragrance notes?",
        "a": "Top: bergamot, pear, ambrette, aldehydes; Heart: jasmine, rose, rosemary, violet, orris; Base: vanilla, musk, moss."
      },
      {
        "q": "Where is Retrospect developed?",
        "a": "It is developed in Paris using master perfumers with the highest quality natural extracts and safe synthetics."
      },
      {
        "q": "Is Retrospect clean, vegan, and cruelty-free?",
        "a": "Yes, Retrospect is Clean at MERIT, vegan, Leaping Bunny certified cruelty-free, and meets EU-compliant standards."
      }
    ]
  },
  "brush-no-1": {
    "handle": "brush-no-1",
    "title": "Brush No. 1",
    "subtitle": "Blending Brush",
    "short_description": "A dense, gently tapered face brush made with ultra-soft vegan fibers.",
    "finish": "Streak-Free Flawless Application",
    "coverage": "Seamless Blending",
    "formula_highlights": [
      "Custom densely-packed vegan bristles gently buff cream makeup without absorbing product",
      "Tapered dome head fits perfectly into contours around eyes, nose, and jawline",
      "FSC-certified wooden handle with comfortable grip balance",
      "Cruelty-free and easy to clean with mild brush soap"
    ],
    "key_ingredients": [
      {
        "name": "Synthetic Vegan Bristles",
        "role": "Precision Fibers",
        "benefit": "Ultra-fine filaments replicate soft goat hair without cruelty"
      }
    ],
    "how_to_use": [
      "Use gentle circular buffing motions to blend The Minimalist, Flush Balm, and Bronze Balm into skin."
    ],
    "faqs": [
      {
        "q": "How do I clean Brush No. 1?",
        "a": "Swirl bristles gently with warm water and brush cleaner or mild soap, rinse thoroughly, reshape head, and lay flat to dry."
      }
    ]
  },
  "brush-no-2": {
    "handle": "brush-no-2",
    "title": "Brush No. 2",
    "subtitle": "Dual-Ended Eyeshadow Brush",
    "short_description": "A dual-ended brush with a fluffy wash brush on one side and a precision liner on the other.",
    "finish": "Effortless Eye Blending",
    "coverage": "Diffused to Precision",
    "formula_highlights": [
      "Fluffy dome end blends Solo Shadow smoothly across entire lid",
      "Angled precision end defines crease and lower lash line",
      "100% vegan bristles engineered specifically for cream-to-powder formulas"
    ],
    "key_ingredients": [
      {
        "name": "Ultra-Fine Vegan Bristles",
        "role": "Eye Bristles",
        "benefit": "Ultra-gentle on delicate eyelid skin"
      }
    ],
    "how_to_use": [
      "Sweep fluffy end across lid for a diffused wash of color. Use angled end along lash line for soft smoky definition."
    ],
    "faqs": [
      {
        "q": "Can Brush No. 2 be used with powder eyeshadows?",
        "a": "Yes! It works equally well with cream, powder, and gel formulas."
      }
    ]
  }
};
window.MERIT_SWATCH_COLORS = {
  "10": "#9A592B",
  "12": "#B77340",
  "14": "#C0874F",
  "15": "#BA7A56",
  "16": "#CE8961",
  "18": "#D89A64",
  "20": "#DDA16F",
  "21": "#E5A371",
  "22": "#EFA672",
  "24": "#DFB186",
  "25": "#EFBC8F",
  "26": "#E0B296",
  "28": "#EAC69F",
  "30": "#E6C3B4",
  "31": "#EFCBB3",
  "1990": "#834D3B",
  "Black": "#000000",
  "Brown": "#523935",
  "Mini": "#000000",
  "Bistre": "#4F3228",
  "Umber": "#5A3F29",
  "Cacao": "#754B33",
  "Sepia": "#6C462C",
  "Taurillon": "#83452D",
  "Tiger Eye": "#955428",
  "Amber": "#A76441",
  "Chestnut": "#955939",
  "Sienna": "#A46B41",
  "Calico": "#B0795A",
  "Buff": "#C18B50",
  "Khaki": "#A17241",
  "Burlwood": "#CB9163",
  "Camel": "#B77645",
  "Suede": "#AD794A",
  "Jute": "#B98F77",
  "Palomino": "#DEAF8B",
  "Sand": "#EDB785",
  "Ochre": "#FFC78E",
  "Bisque": "#F5B785",
  "Oak": "#DDB18C",
  "Sandstone": "#DFB89B",
  "Ecru": "#FFCD97",
  "Dune": "#F4BF9E",
  "Linen": "#ECC195",
  "Bone": "#E8C1A9",
  "Cream": "#F4C199",
  "Silk": "#F5C19E",
  "Chiffon": "#E7D0B9",
  "Ceramic": "#DBC6C0",
  "Beverly Hills": "#C76153",
  "Stockholm": "#E17C8C",
  "Archival": "#A95E62",
  "Cheeky": "#B25659",
  "Le Bonbon": "#D33762",
  "Fox": "#AA5048",
  "Après": "#872230",
  "Postmodern": "#661E1D",
  "Persimmon": "#B93721",
  "Lusitano": "#E1544B",
  "Rouge": "#EB2B41",
  "Terracotta": "#B26C52",
  "Bespoke": "#814A4A",
  "The Cool Plums": "#814C5E",
  "The Brown Pinks": "#915E51",
  "The Soft Pinks": "#DF9597",
  "The Bright Pinks": "#B75157",
  "The Rose Browns": "#a06e6f",
  "The Cool Berries": "#AC6068",
  "The Warm Browns": "#C68B7D",
  "Rose": "#DF9597",
  "June": "#C68B7D",
  "Cassis": "#B75157",
  "Subconscious": "#AC6068",
  "Cowboy": "#915E51",
  "Bauhaus": "#814C5E",
  "Coupé": "#ba8385",
  "Sportif": "#884a2e",
  "Mayfair": "#a4676e",
  "Brownstone": "#795148",
  "Tabac": "#8e645a",
  "Capricorn": "#674e40",
  "Studio": "#B68A7C",
  "Vachetta": "#B38061",
  "Midcentury": "#9C6D58",
  "Brun": "#5C3724",
  "Nelson": "#5F5049",
  "Social": "#8D6F7B",
  "Iris": "#916560",
  "Glacé": "#D59A8B",
  "Matchbook": "#753732",
  "Sartorial": "#7C5142",
  "Palladium": "#D7B69F",
  "Surrealism": "#DBA483",
  "Viper": "#555340",
  "Midnight": "#2F3357",
  "Jeté": "#D46551",
  "Les Deux": "#E11F4D",
  "Maraschino": "#D32128",
  "Mapleton": "#95212E",
  "Taupe": "#CA896D",
  "Marrakech": "#A8523E",
  "Sangria": "#6B2606",
  "Tabby": "#633125",
  "Pink Beet": "#A94E49",
  "Pointelle": "#AF5452",
  "Biarritz": "#AF5948",
  "Twin Set": "#94494A",
  "Vendôme": "#AB5E4C",
  "Andie": "#D07177",
  "Kitten Heel": "#D0473F",
  "Framboise": "#A93647",
  "September": "#9F2B2B",
  "Gamay": "#9D3B3A",
  "02": "#41281B",
  "03": "#461B0A",
  "04": "#5F3420",
  "06": "#794A2B",
  "08": "#8C4F38",
  "Perfect Black": "#000000",
  "Quince": "#C9996D",
  "Clay": "#AC7F59",
  "Seine": "#875F42",
  "Leo": "#644332",
  "Monarch": "#331A08",
  "Light Brown": "#6e5349",
  "Dark Brown": "#483834",
  "Brown Black": "#312c29",
  "Brown-Black": "#312c29",
  "Solstice": "#925847",
  "Citrine": "#DDAC78",
  "Cava": "#DEC3A8",
  "Bounce": "#BC816E",
  "Tiger": "#98321A",
  "Baby": "#D98880",
  "Millennial": "#E9989E",
  "L'Avenue": "#A7413E",
  "Ginger": "#AF5346",
  "Power": "#A11633",
  "Vermillion": "#B20317",
  "Sunday": "#BF3F4E",
  "Antibes": "#914334",
  "Classic": "#AA5249",
  "Maison": "#913E43",
  "Equestrian": "#7B3128",
  "Court": "#A72328",
  "Slip": "#BB7E6A"
};
